import React from 'react';

const ToolbarIcons = {
  SearchIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--text-faint)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 16 16"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g clipPath="url(#clip0_6012_105)">
    //     <path
    //       d="M13.4393 15.5607C14.0251 16.1464 14.9749 16.1464 15.5607 15.5607C16.1464 14.9749 16.1464 14.0251 15.5607 13.4393L13.4393 15.5607ZM9.93934 12.0607L13.4393 15.5607L15.5607 13.4393L12.0607 9.93934L9.93934 12.0607Z"
    //       fill={fill}
    //     />
    //     <circle cx="6" cy="6" r="5" stroke={fill} strokeWidth="2" />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_6012_105">
    //       <rect width={width} height={height} fill="white" />
    //     </clipPath>
    //   </defs>
    // </svg>

    <svg
      viewBox="0 0 24 24"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      fill="none"
      stroke={fill}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="7" stroke={fill}></circle>
      <path d="m20 20-3.2-3.2" stroke={fill}></path>
    </svg>
  ),
  SendMessageIcon: ({
    width = '20px',
    height = '20px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6024_6924)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.121632 14.6377C-0.284827 15.4506 0.516189 16.3403 1.36718 16.0212L7.99942 13.5341L14.6317 16.0212C15.4827 16.3403 16.2837 15.4506 15.8772 14.6377L8.89385 0.67095C8.52532 -0.066097 7.47352 -0.0660989 7.105 0.67095L0.121632 14.6377ZM7.49951 2.11799L1.01606 15.0849L7.49951 12.6536L7.49951 2.11799ZM8.49951 12.6537L14.9828 15.0849L8.49951 2.11834L8.49951 12.6537Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_6024_6924">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  SendMessageIconFull: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6058_9686)">
        <path d="M6 -0.00012207H7V15.9999H0V11.9999L6 -0.00012207Z" fill={fill} />
        <path d="M10 -0.00012207L16 11.9999V15.9999H9V-0.00012207H10Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_6058_9686">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ReloadIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6058_9680)">
        <circle cx="8" cy="8" r="7" stroke={fill} strokeWidth="2" />
        <path d="M10 5H15V0" stroke={fill} strokeWidth="2" />
        <rect x="12" y="6" width="4" height="5" fill="var(--bg-form-color)" />
      </g>
      <defs>
        <clipPath id="clip0_6058_9680">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  PinIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-text)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 10.5L9.5 9.5C10.6046 8.39543 10.6046 6.60457 9.5 5.5C8.39543 4.39543 6.60457 4.39543 5.5 5.5L2.5 8.5C1.39543 9.60457 1.39543 11.3954 2.5 12.5L3 13C3.82843 13.8284 5.17157 13.8284 6 13M7.5 6.5L6.5 7.5C5.39543 8.60457 5.39543 10.3954 6.5 11.5C7.60457 12.6046 9.39543 12.6046 10.5 11.5L13.5 8.5C14.6046 7.39543 14.6046 5.60457 13.5 4.5L13 4C12.1716 3.17157 10.8284 3.17157 10 4"
        stroke={fill}
        strokeLinecap="round"
      />
    </svg>
  ),
  EmojiIcon: ({
    width = '20px',
    height = '20px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6024_6918)">
        <circle cx="8" cy="8" r="7.5" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M4.5 10.5C6 13 10 13 11.5 10.5"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="5" cy="6" r="0.5" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="11" cy="6" r="0.5" stroke={fill} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_6024_6918">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  AiIcon: ({
    width = '20px',
    height = '20px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6024_6910)">
        <path
          d="M8.13086 3.1123C8.35376 3.68549 8.60067 4.28142 8.86328 4.80664C9.11534 5.31076 9.42386 5.83793 9.79297 6.20703C10.1621 6.57614 10.6892 6.88466 11.1934 7.13672C11.7186 7.39933 12.3145 7.64624 12.8877 7.86914C13.0039 7.91434 13.1215 7.95609 13.2373 8C13.1215 8.04391 13.0039 8.08566 12.8877 8.13086C12.3145 8.35376 11.7186 8.60067 11.1934 8.86328C10.6892 9.11534 10.1621 9.42386 9.79297 9.79297C9.42386 10.1621 9.11534 10.6892 8.86328 11.1934C8.60067 11.7186 8.35376 12.3145 8.13086 12.8877C8.08566 13.0039 8.04391 13.1215 8 13.2373C7.95609 13.1215 7.91434 13.0039 7.86914 12.8877C7.64624 12.3145 7.39933 11.7186 7.13672 11.1934C6.88466 10.6892 6.57614 10.1621 6.20703 9.79297C5.83793 9.42386 5.31076 9.11534 4.80664 8.86328C4.28142 8.60067 3.68549 8.35376 3.1123 8.13086C2.99579 8.08555 2.8778 8.04402 2.76172 8C2.8778 7.95598 2.99579 7.91445 3.1123 7.86914C3.68549 7.64624 4.28142 7.39933 4.80664 7.13672C5.31076 6.88466 5.83793 6.57614 6.20703 6.20703C6.57614 5.83793 6.88466 5.31076 7.13672 4.80664C7.39933 4.28142 7.64624 3.68549 7.86914 3.1123C7.91445 2.99579 7.95598 2.8778 8 2.76172C8.04402 2.8778 8.08555 2.99579 8.13086 3.1123Z"
          stroke={fill}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_6024_6910">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  CloseIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.293 5.29297C17.6835 4.90244 18.3165 4.90244 18.707 5.29297C19.0976 5.68349 19.0976 6.31651 18.707 6.70703L13.4141 12L18.707 17.293C19.0976 17.6835 19.0976 18.3165 18.707 18.707C18.3165 19.0976 17.6835 19.0976 17.293 18.707L12 13.4141L6.70703 18.707C6.31651 19.0976 5.68349 19.0976 5.29297 18.707C4.90244 18.3165 4.90244 17.6835 5.29297 17.293L10.5859 12L5.29297 6.70703C4.90244 6.31651 4.90244 5.68349 5.29297 5.29297C5.68349 4.90244 6.31651 4.90244 6.70703 5.29297L12 10.5859L17.293 5.29297Z"
        fill={fill}
      />
    </svg>
  ),
  CloseCircleIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="16.0002" height="16.0002" rx="8" fill="#8F9099" />
      <path
        d="M9.92676 5.18457C10.1723 4.93902 10.5709 4.93902 10.8164 5.18457C11.0616 5.43002 11.0615 5.82774 10.8164 6.07324L8.88867 8L10.8164 9.92676C11.0619 10.1723 11.0619 10.5709 10.8164 10.8164C10.5709 11.0619 10.1723 11.0619 9.92676 10.8164L8 8.88867L6.07324 10.8164C5.82774 11.0615 5.43002 11.0616 5.18457 10.8164C4.93902 10.5709 4.93902 10.1723 5.18457 9.92676L7.11035 8L5.18457 6.07324C4.93915 5.82768 4.93906 5.43008 5.18457 5.18457C5.43008 4.93906 5.82768 4.93915 6.07324 5.18457L8 7.11035L9.92676 5.18457Z"
        fill={fill}
      />
    </svg>
  ),
  BurgerIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M19.1113 17C19.6021 17.0001 20 17.4478 20 18C20 18.5522 19.6021 18.9999 19.1113 19H4.88867C4.39785 18.9999 4 18.5522 4 18C4 17.4478 4.39785 17.0001 4.88867 17H19.1113ZM19.1113 11C19.6021 11.0001 20 11.4478 20 12C20 12.5522 19.6021 12.9999 19.1113 13H4.88867C4.39785 12.9999 4 12.5522 4 12C4 11.4478 4.39785 11.0001 4.88867 11H19.1113ZM19.1113 5C19.6021 5.00013 20 5.4478 20 6C20 6.5522 19.6021 6.99987 19.1113 7H4.88867C4.39785 6.99987 4 6.5522 4 6C4 5.4478 4.39785 5.00013 4.88867 5H19.1113Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M41.07,16.79H9.74c-2.47,0-2.4-2.79,0-2.86H41.1C43.1,13.93,43.54,16.75,41.07,16.79Zm0,21.16H9.74c-2.47,0-2.4-2.79,0-2.86H41.1C43.1,35.09,43.54,37.91,41.07,38Zm0-10.92H9.74c-2.47-.12-2.4-2.87,0-2.87H41.1C43.1,24.16,43.54,27,41.07,27Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  SigninIcon: ({ width = '16px', height = '16px', fill = 'var(--icon-color)', onClick = null }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1263_1488)">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 3C16.96 3 21 7.04 21 12C21 13.42 20.66 14.76 20.07 15.96C18.54 14.24 16.09 13.07 12.69 12.93C14.57 12.6 16 10.97 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9C8 10.97 9.43 12.6 11.31 12.93C7.91 13.07 5.46 14.24 3.93 15.96C3.34 14.76 3 13.42 3 12C3 7.04 7.04 3 12 3ZM9 9C9 7.35 10.35 6 12 6C13.65 6 15 7.35 15 9C15 10.65 13.65 12 12 12C10.35 12 9 10.65 9 9ZM12 21C8.84 21 6.06 19.36 4.45 16.88C6.01 14.93 8.61 13.9 12 13.9C15.39 13.9 17.99 14.93 19.55 16.88C17.94 19.36 15.16 21 12 21Z"
          fill="#EFF0FA"
        />
      </g>
      <defs>
        <clipPath id="clip0_1263_1488">
          <rect width="24" height="24" fill={fill} />
        </clipPath>
      </defs>
    </svg>
  ),
  NotificationIconFill: ({
    width = '16px',
    height = '16px',
    fill = 'var(--link-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   width={width}
    //   onClick={onClick}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g clipPath="url(#clip0_1263_1484)">
    //     <path
    //       d="M19.2016 3.32737C18.9304 2.96582 18.4175 2.89255 18.056 3.16371C17.6944 3.43488 17.6211 3.94779 17.8923 4.30935C18.8484 5.58417 19.3653 7.13471 19.3653 8.72823C19.3653 9.18017 19.7316 9.54654 20.1836 9.54654C20.6355 9.54654 21.0019 9.18017 21.0019 8.72823C21.0019 6.78059 20.3702 4.88549 19.2016 3.32737Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M5.95104 3.16832C6.31005 3.44285 6.37852 3.95644 6.10399 4.31544C5.15258 5.5596 4.63565 7.1022 4.63565 8.72823C4.63565 9.18017 4.26928 9.54654 3.81734 9.54654C3.36539 9.54654 2.99902 9.18017 2.99902 8.72823C2.99902 6.75368 3.62773 4.85937 4.80393 3.32127C5.07846 2.96227 5.59204 2.89379 5.95104 3.16832Z"
    //       fill={fill}
    //     />
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M12.0005 3.00006C10.4812 3.00006 9.02426 3.60356 7.95002 4.6778C6.87577 5.75205 6.27227 7.20903 6.27227 8.72824C6.27227 11.4718 5.68548 13.1755 5.14472 14.1669C4.87321 14.6646 4.60883 14.9912 4.42517 15.185C4.33313 15.2822 4.26081 15.3466 4.21726 15.3829C4.19548 15.4011 4.18087 15.4122 4.17457 15.4169L4.17223 15.4186C3.87887 15.6201 3.74906 15.9887 3.85245 16.3302C3.95694 16.6753 4.27504 16.9114 4.63565 16.9114H19.3653C19.7259 16.9114 20.044 16.6753 20.1485 16.3302C20.2519 15.9887 20.122 15.6201 19.8287 15.4186L19.8263 15.4169C19.82 15.4122 19.8054 15.4011 19.7836 15.3829C19.7401 15.3466 19.6678 15.2822 19.5757 15.185C19.3921 14.9912 19.1277 14.6646 18.8562 14.1669C18.3154 13.1755 17.7286 11.4718 17.7286 8.72824C17.7286 7.20903 17.1251 5.75205 16.0509 4.6778C14.9767 3.60356 13.5197 3.00006 12.0005 3.00006ZM17.6064 15.2747H6.39446C6.45673 15.1727 6.51923 15.0647 6.58151 14.9506C7.26821 13.6916 7.90889 11.7129 7.90889 8.72824C7.90889 7.64309 8.33997 6.60239 9.10728 5.83507C9.8746 5.06776 10.9153 4.63668 12.0005 4.63668C13.0856 4.63668 14.1263 5.06776 14.8936 5.83507C15.6609 6.60239 16.092 7.64309 16.092 8.72824C16.092 11.7129 16.7327 13.6916 17.4194 14.9506C17.4817 15.0647 17.5442 15.1727 17.6064 15.2747Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M11.2926 18.9557C11.0658 18.5648 10.5651 18.4317 10.1742 18.6585C9.78324 18.8852 9.65017 19.386 9.87694 19.7769C10.0927 20.1489 10.4025 20.4577 10.7752 20.6724C11.1478 20.887 11.5704 21 12.0005 21C12.4305 21 12.8531 20.887 13.2257 20.6724C13.5984 20.4577 13.9082 20.1489 14.124 19.7769C14.3507 19.386 14.2177 18.8852 13.8267 18.6585C13.4358 18.4317 12.9351 18.5648 12.7083 18.9557C12.6364 19.0797 12.5331 19.1826 12.4089 19.2542C12.2847 19.3257 12.1438 19.3634 12.0005 19.3634C11.8571 19.3634 11.7163 19.3257 11.592 19.2542C11.4678 19.1826 11.3646 19.0797 11.2926 18.9557Z"
    //       fill={fill}
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_1263_1484">
    //       <rect width={width} height={height} fill={fill} />
    //     </clipPath>
    //   </defs>
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      onClick={onClick}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M38.49,35.47,35.8,32.78V23a12.22,12.22,0,0,0-2.17-7.28A9.62,9.62,0,0,0,28,11.93l-.65-.13v-2a1.78,1.78,0,0,0-.59-1.37,2,2,0,0,0-1.38-.6,1.79,1.79,0,0,0-1.38.6,2.06,2.06,0,0,0-.59,1.37v2l-.65.13a9.32,9.32,0,0,0-5.64,3.8A12.72,12.72,0,0,0,15,23v9.77l-2.69,2.69a1,1,0,0,0-.33.72.77.77,0,0,0,.07.39,1.37,1.37,0,0,0,.19.33.89.89,0,0,0,.72.26H37.76a1.23,1.23,0,0,0,.73-.26c.13-.13.19-.2.19-.33a.77.77,0,0,0,.07-.39h0a.85.85,0,0,0-.33-.72Zm-.92-3.41,2.16,2.16a2.63,2.63,0,0,1,.79,2h0a2.77,2.77,0,0,1-.2,1.05,2.63,2.63,0,0,1-2.56,1.7H12.91a2.93,2.93,0,0,1-2-.78h0a2.68,2.68,0,0,1-.59-.92,3,3,0,0,1-.2-1.05,2.88,2.88,0,0,1,.79-2l2.16-2.16V23a14.21,14.21,0,0,1,2.49-8.33,11.34,11.34,0,0,1,6-4.32V9.77a3.49,3.49,0,0,1,1.12-2.63h0A3.72,3.72,0,0,1,25.37,6,3.45,3.45,0,0,1,28,7.14a3.72,3.72,0,0,1,1.12,2.63v.59a11.3,11.3,0,0,1,6,4.32A14.21,14.21,0,0,1,37.63,23v9.05ZM30,40a4.57,4.57,0,0,1-1.38,3.28h0a4.67,4.67,0,0,1-3.28,1.38,4.58,4.58,0,0,1-3.28-1.38A4.66,4.66,0,0,1,20.72,40V38.62H30V40Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  NotificationIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   width={width}
    //   height={height}
    //   fill={fill}
    //   onClick={onClick}
    //   className={className}
    //   viewBox="0 0 32 32"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M25.7203 22.72L24.0002 21V14.3333C24.0002 10.24 21.8136 6.81333 18.0003 5.90667V5C18.0003 3.89333 17.1069 3 16.0003 3C14.8936 3 14.0003 3.89333 14.0003 5V5.90667C10.1736 6.81333 8.00025 10.2267 8.00025 14.3333V21L6.28025 22.72C5.44025 23.56 6.02692 25 7.21358 25H24.7736C25.9736 25 26.5603 23.56 25.7203 22.72ZM10.6669 22.3333V14.3333C10.6669 11.0267 12.6803 8.33333 16.0003 8.33333C19.3203 8.33333 21.3336 11.0267 21.3336 14.3333V22.3333H10.6669ZM18.6669 26.3333C18.6669 27.8 17.4669 29 16.0003 29C14.5203 29 13.3336 27.8 13.3336 26.3333H18.6669Z"
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      onClick={onClick}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M38.49,35.47,35.8,32.78V23a12.22,12.22,0,0,0-2.17-7.28A9.62,9.62,0,0,0,28,11.93l-.65-.13v-2a1.78,1.78,0,0,0-.59-1.37,2,2,0,0,0-1.38-.6,1.79,1.79,0,0,0-1.38.6,2.06,2.06,0,0,0-.59,1.37v2l-.65.13a9.32,9.32,0,0,0-5.64,3.8A12.72,12.72,0,0,0,15,23v9.77l-2.69,2.69a1,1,0,0,0-.33.72.77.77,0,0,0,.07.39,1.37,1.37,0,0,0,.19.33.89.89,0,0,0,.72.26H37.76a1.23,1.23,0,0,0,.73-.26c.13-.13.19-.2.19-.33a.77.77,0,0,0,.07-.39h0a.85.85,0,0,0-.33-.72Zm-.92-3.41,2.16,2.16a2.63,2.63,0,0,1,.79,2h0a2.77,2.77,0,0,1-.2,1.05,2.63,2.63,0,0,1-2.56,1.7H12.91a2.93,2.93,0,0,1-2-.78h0a2.68,2.68,0,0,1-.59-.92,3,3,0,0,1-.2-1.05,2.88,2.88,0,0,1,.79-2l2.16-2.16V23a14.21,14.21,0,0,1,2.49-8.33,11.34,11.34,0,0,1,6-4.32V9.77a3.49,3.49,0,0,1,1.12-2.63h0A3.72,3.72,0,0,1,25.37,6,3.45,3.45,0,0,1,28,7.14a3.72,3.72,0,0,1,1.12,2.63v.59a11.3,11.3,0,0,1,6,4.32A14.21,14.21,0,0,1,37.63,23v9.05ZM30,40a4.57,4.57,0,0,1-1.38,3.28h0a4.67,4.67,0,0,1-3.28,1.38,4.58,4.58,0,0,1-3.28-1.38A4.66,4.66,0,0,1,20.72,40V38.62H30V40Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  MoreIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8" cy="8" r="1" fill={fill} />
      <circle cx="8" cy="3" r="1" fill={fill} />
      <circle cx="8" cy="13" r="1" fill={fill} />
    </svg>
  ),
  ChangeModeIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g clipPath="url(#clip0_884_1304)">
    //     <path
    //       d="M12 3C12.4519 3 12.8182 3.36631 12.8182 3.81818V5.45455C12.8182 5.90641 12.4519 6.27273 12 6.27273C11.5481 6.27273 11.1818 5.90641 11.1818 5.45455V3.81818C11.1818 3.36631 11.5481 3 12 3Z"
    //       fill={fill}
    //     />
    //     <path
    //       fillRule="evenodd"
    //       clipRule="evenodd"
    //       d="M7.90909 12.0001C7.90909 9.74072 9.74065 7.90915 12 7.90915C14.2593 7.90915 16.0909 9.74072 16.0909 12.0001C16.0909 14.2594 14.2593 16.091 12 16.091C9.74065 16.091 7.90909 14.2594 7.90909 12.0001ZM12 9.54552C10.6444 9.54552 9.54545 10.6445 9.54545 12.0001C9.54545 13.3557 10.6444 14.4546 12 14.4546C13.3556 14.4546 14.4545 13.3557 14.4545 12.0001C14.4545 10.6445 13.3556 9.54552 12 9.54552Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M12.8182 18.5455C12.8182 18.0936 12.4519 17.7273 12 17.7273C11.5481 17.7273 11.1818 18.0936 11.1818 18.5455V20.1818C11.1818 20.6337 11.5481 21 12 21C12.4519 21 12.8182 20.6337 12.8182 20.1818V18.5455Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M5.69419 5.69422C6.01371 5.3747 6.53175 5.3747 6.85127 5.69422L8.07854 6.92149C8.39806 7.24101 8.39806 7.75905 8.07854 8.07857C7.75902 8.39809 7.24098 8.39809 6.92146 8.07857L5.69419 6.8513C5.37467 6.53178 5.37467 6.01374 5.69419 5.69422Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M17.0785 15.9215C16.759 15.602 16.241 15.602 15.9215 15.9215C15.6019 16.241 15.6019 16.7591 15.9215 17.0786L17.1487 18.3059C17.4683 18.6254 17.9863 18.6254 18.3058 18.3059C18.6253 17.9863 18.6253 17.4683 18.3058 17.1488L17.0785 15.9215Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M3 12C3 11.5482 3.36631 11.1819 3.81818 11.1819H5.45455C5.90641 11.1819 6.27273 11.5482 6.27273 12C6.27273 12.4519 5.90641 12.8182 5.45455 12.8182H3.81818C3.36631 12.8182 3 12.4519 3 12Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M18.5454 11.1819C18.0936 11.1819 17.7273 11.5482 17.7273 12C17.7273 12.4519 18.0936 12.8182 18.5454 12.8182H20.1818C20.6337 12.8182 21 12.4519 21 12C21 11.5482 20.6337 11.1819 20.1818 11.1819H18.5454Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M8.07854 15.9215C8.39806 16.241 8.39806 16.7591 8.07854 17.0786L6.85127 18.3059C6.53175 18.6254 6.01371 18.6254 5.69419 18.3059C5.37467 17.9863 5.37467 17.4683 5.69419 17.1488L6.92146 15.9215C7.24098 15.602 7.75902 15.602 8.07854 15.9215Z"
    //       fill={fill}
    //     />
    //     <path
    //       d="M18.3058 6.8513C18.6253 6.53178 18.6253 6.01374 18.3058 5.69422C17.9863 5.3747 17.4683 5.3747 17.1487 5.69422L15.9215 6.92149C15.6019 7.24101 15.6019 7.75905 15.9215 8.07857C16.241 8.39809 16.759 8.39809 17.0785 8.07857L18.3058 6.8513Z"
    //       fill={fill}
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_884_1304">
    //       <rect width={width} height={height} fill={fill} />
    //     </clipPath>
    //   </defs>
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M25.55,14a11.23,11.23,0,1,1-7.94,19.17A11.23,11.23,0,0,1,25.55,14Zm9,2.22h0a1.17,1.17,0,0,1,0-1.72L37,12a1.34,1.34,0,0,1,1.83,0h0a1.17,1.17,0,0,1,0,1.72l-2.43,2.43A1.33,1.33,0,0,1,34.57,16.19ZM38,25.06h0a1.2,1.2,0,0,1,1.22-1.29l3.21,0A1.37,1.37,0,0,1,43.79,25h0a1.2,1.2,0,0,1-1.21,1.28l-3.22,0A1.36,1.36,0,0,1,38,25.06Zm-3.47,8.83h0a1.28,1.28,0,0,1,1.82,0l2.33,2.25a1.29,1.29,0,0,1,0,1.82h0a1.3,1.3,0,0,1-1.83,0l-2.32-2.26A1.29,1.29,0,0,1,34.53,33.89Zm-9,3.83h0A1.28,1.28,0,0,1,26.84,39v3.25a1.28,1.28,0,0,1-1.29,1.29h0a1.28,1.28,0,0,1-1.28-1.29V39A1.28,1.28,0,0,1,25.55,37.72Zm-13.23.75h0a1.17,1.17,0,0,1,0-1.72l2.44-2.43a1.33,1.33,0,0,1,1.82,0h0a1.17,1.17,0,0,1,0,1.72l-2.44,2.43A1.33,1.33,0,0,1,12.32,38.47Zm-5-13h0a1.2,1.2,0,0,1,1.21-1.29l3.22,0a1.36,1.36,0,0,1,1.36,1.25h0a1.2,1.2,0,0,1-1.21,1.29l-3.22,0A1.36,1.36,0,0,1,7.28,25.45ZM12.39,12.5h0a1.3,1.3,0,0,1,1.83,0l2.32,2.25a1.3,1.3,0,0,1,0,1.83h0a1.3,1.3,0,0,1-1.83,0l-2.32-2.25A1.3,1.3,0,0,1,12.39,12.5ZM25.55,6.92h0a1.29,1.29,0,0,1,1.29,1.29v3.26a1.28,1.28,0,0,1-1.29,1.28h0a1.28,1.28,0,0,1-1.28-1.28V8.21A1.28,1.28,0,0,1,25.55,6.92ZM32.1,18.69a9.23,9.23,0,1,0,2.72,6.55A9.19,9.19,0,0,0,32.1,18.69Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  ChangeModeIconNight: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M27.4,10.51A14,14,0,1,1,16.65,35.64a13.76,13.76,0,0,1-5.1-6.84L11,27.16l1.69.31a9.81,9.81,0,0,0,1.11.18,10.21,10.21,0,0,0,1.15,0,11.95,11.95,0,0,0,12-12,10.46,10.46,0,0,0-.17-2,13.32,13.32,0,0,0-.49-1.91l-.58-1.64,1.69.31ZM34,16.59a12.1,12.1,0,0,0-5.37-3.73,2.45,2.45,0,0,1,.09.53,13.9,13.9,0,0,1,.17,2.31,13.93,13.93,0,0,1-14,14,7.09,7.09,0,0,1-.89,0,12,12,0,0,0,10.66,6.53,12,12,0,0,0,9.24-19.63Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  HomeIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      // fill={fill}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M25.37,7.06C30.06,11.67,41.81,23.27,45.57,27a.93.93,0,0,1,0,1.51,1.1,1.1,0,0,1-1.5-.29c-5.6-5.59-12.78-12.92-18.42-18.41-.33-.29-.24-.29-.57,0-5.64,5.49-13,13-18.6,18.6A1.15,1.15,0,0,1,5,28.53,1,1,0,0,1,5.07,27c3.76-4,15.55-15.41,20.25-20Zm-.43,21.52h1a2.26,2.26,0,0,1,2.25,2.26v5.87A2.25,2.25,0,0,1,26,39h-1a2.25,2.25,0,0,1-2.25-2.25V30.84A2.26,2.26,0,0,1,24.94,28.58Zm-9.49,13c5.36,0,14.52,0,19.88,0,2.58-.05,3-.66,3-3.15s0-8.32,0-11.09c0-.8.47-1.13.94-1.13s.89.38.89,1.18c0,3.8.05,8.36,0,12.12,0,2.25-1.32,4.09-4.61,4.09H15.26c-3.29,0-4.55-1.84-4.6-4.09-.05-3.81,0-8.41,0-12.22,0-.61.28-1.13.94-1.08s.84.8.84,1.08c0,2.77,0,8.51,0,11.14s.37,3.1,3,3.15Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g clipPath="url(#clip0_3841_4120)">
    //     <path
    //       d="M2.71436 13.4283L12.0001 4.14258L21.2858 13.4283"
    //       stroke={fill}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //     <path
    //       d="M5.57129 10.5713V19.857H18.4284V10.5713"
    //       stroke={fill}
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_3841_4120">
    //       <rect width="24" height="24" fill="white" />
    //     </clipPath>
    //   </defs>
    // </svg>
  ),
  // PlaylistIcon: ({
  //   width = '16px',
  //   height = '16px',
  //   fill = 'var(--icon-color)',
  //   onClick = null,
  // }) => (
  //   // <svg
  //   //   onClick={onClick}
  //   //   width={width}
  //   //   height={height}
  //   //   viewBox="0 0 24 24"
  //   //   fill="none"
  //   //   xmlns="http://www.w3.org/2000/svg"
  //   // >
  //   //   <g clipPath="url(#clip0_3841_4132)">
  //   //     <g clipPath="url(#clip1_3841_4132)">
  //   //       <path
  //   //         d="M11 7L17 10.5L11 14V7ZM18 20H4V6H3V21H18V20ZM21 18H6V3H21V18ZM7 17H20V4H7V17Z"
  //   //         fill={fill}
  //   //       />
  //   //     </g>
  //   //   </g>
  //   //   <defs>
  //   //     <clipPath id="clip0_3841_4132">
  //   //       <rect width="24" height="24" fill="white" />
  //   //     </clipPath>
  //   //     <clipPath id="clip1_3841_4132">
  //   //       <rect width="24" height="24" fill="white" />
  //   //     </clipPath>
  //   //   </defs>
  //   // </svg>

  //   <svg
  //     id="Layer_1"
  //     data-name="Layer 1"
  //     xmlns="http://www.w3.org/2000/svg"
  //     onClick={onClick}
  //     width={width}
  //     height={height}
  //     viewBox="0 0 50.68 50.68"
  //   >
  //     <g id="Layer_1-2" data-name="Layer_1">
  //       <path
  //         d="M12,15.32c4.61.06,9.16.12,13.77.12s9.17-.06,13.72-.18h0a4.2,4.2,0,0,1,2.77.93,3.78,3.78,0,0,1,1.21,2.59h0V39.53h0a3.65,3.65,0,0,1-1,2.6,3.71,3.71,0,0,1-2.53,1.09c-9.46,0-19-.06-28.48-.06A3.92,3.92,0,0,1,8.62,41.9,4.58,4.58,0,0,1,7.41,39h0V19.13A3.42,3.42,0,0,1,9,16a5.18,5.18,0,0,1,2.88-.75H12ZM10.58,11.4H40a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H10.58a1,1,0,0,1-1-1h0A1,1,0,0,1,10.58,11.4Zm3.35-3.17H36.29A.79.79,0,0,1,37.1,9h0a.79.79,0,0,1-.81.8H13.93a.78.78,0,0,1-.81-.8h0A.79.79,0,0,1,13.93,8.23Zm9.51,15.91c1.32.87,4.84,3.17,6.63,4.27a1,1,0,0,1,.11,1.73c-2,1.49-4.5,3-6.63,4.38a1.23,1.23,0,0,1-2-.93c0-2.24-.05-6.16-.05-8.47A1.3,1.3,0,0,1,22,24a1.15,1.15,0,0,1,1.38.17Zm2.3-6.74c-4.61,0-9.16-.06-13.77-.12h-.06a3.64,3.64,0,0,0-1.79.4,1.72,1.72,0,0,0-.69,1.5V39a2.39,2.39,0,0,0,.69,1.62,1.9,1.9,0,0,0,1.44.63l28.31.06a2,2,0,0,0,1.26-.52,2,2,0,0,0,.46-1.27V18.78a1.45,1.45,0,0,0-.51-1.1,2.27,2.27,0,0,0-1.5-.46h0c-4.61.12-9.17.18-13.78.18Z"
  //         fill={fill}
  //       />
  //     </g>
  //   </svg>
  // ),
  ChannelIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M10 18V12L15 15L10 18ZM17 3H7V4H17V3ZM20 6H4V7H20V6ZM22 9H2V21H22V9ZM3 10H21V20H3V10Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M46.51,17.92V33.37a1,1,0,0,1-1.49.72c-.62-.36-1.6-1-2.57-1.59L40.7,31.41V36.1a6,6,0,0,1-1.76,4.33,6.38,6.38,0,0,1-4.37,1.8H10.93a7,7,0,0,1-4.12-2A6,6,0,0,1,4.7,36.1V15A6.76,6.76,0,0,1,6.3,10.2a6.1,6.1,0,0,1,4.58-1.75H34.52a6.26,6.26,0,0,1,4.42,1.65,6.64,6.64,0,0,1,1.76,4.84v4.73l1.64-1L45,17.1a1,1,0,0,1,1.49.88ZM10.32,34h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.88H10.32a.87.87,0,0,1-.88-.88V34.86A.87.87,0,0,1,10.32,34Zm5.61,0h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.88H15.93a.87.87,0,0,1-.88-.88V34.86A.87.87,0,0,1,15.93,34Zm5.51,0H23.7a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.88H21.44a.87.87,0,0,1-.88-.88V34.86A.87.87,0,0,1,21.44,34ZM27,34h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.88H27a.87.87,0,0,1-.88-.88V34.86A.87.87,0,0,1,27,34Zm5.51,0h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.88H32.46a.87.87,0,0,1-.88-.88V34.86A.87.87,0,0,1,32.46,34ZM10.32,13.24h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.87H10.32a.87.87,0,0,1-.88-.87V14.11A.87.87,0,0,1,10.32,13.24Zm5.61,0h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.87H15.93a.87.87,0,0,1-.88-.87V14.11A.87.87,0,0,1,15.93,13.24Zm5.51,0H23.7a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.87H21.44a.87.87,0,0,1-.88-.87V14.11A.87.87,0,0,1,21.44,13.24Zm5.51,0h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.87H27a.87.87,0,0,1-.88-.87V14.11A.87.87,0,0,1,27,13.24Zm5.51,0h2.26a.87.87,0,0,1,.88.87v2.27a.87.87,0,0,1-.88.87H32.46a.87.87,0,0,1-.88-.87V14.11A.87.87,0,0,1,32.46,13.24Zm12,17V20.91a.69.69,0,0,0-1-.67l-4.79,2.88V14.94a4.63,4.63,0,0,0-1.19-3.45,4.13,4.13,0,0,0-3-1.08H10.78a4.23,4.23,0,0,0-3.14,1.08,5,5,0,0,0-1,3.5V36.05A4.23,4.23,0,0,0,8.1,38.78a4.52,4.52,0,0,0,2.78,1.39H34.41a4.24,4.24,0,0,0,3.09-1.24,3.94,3.94,0,0,0,1.19-2.78V27.71l4.79,3.09a.66.66,0,0,0,1-.52Zm-23-9.73L24,22.09c1,.67,2.11,1.4,2.73,1.76a3.31,3.31,0,0,1,.51.46,1.75,1.75,0,0,1,.37,1,1.86,1.86,0,0,1-.26,1c.05.05-.41.46-.47.51A57.73,57.73,0,0,1,22,30l-.41.26a2,2,0,0,1-1.18.36,2.08,2.08,0,0,1-.93-.2c-.1-.06-.82-.62-.72-.67a1.72,1.72,0,0,1-.31-1V22.09a2,2,0,0,1,.21-1,1.87,1.87,0,0,1,.67-.72,2,2,0,0,1,1-.25A2.15,2.15,0,0,1,21.49,20.5Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  CategoryIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <g clipPath="url(#clip0_3860_4522)">
    //     <g clipPath="url(#clip1_3860_4522)">
    //       <path
    //         d="M19.7144 11.3564H14.5716C14.2165 11.3564 13.9287 11.6443 13.9287 11.9993V19.7136C13.9287 20.0686 14.2165 20.3564 14.5716 20.3564H19.7144C20.0694 20.3564 20.3573 20.0686 20.3573 19.7136V11.9993C20.3573 11.6443 20.0694 11.3564 19.7144 11.3564Z"
    //         stroke={fill}
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M19.7144 3.64258H14.5716C14.2165 3.64258 13.9287 3.9304 13.9287 4.28544V6.86972C13.9287 7.22476 14.2165 7.51258 14.5716 7.51258H19.7144C20.0694 7.51258 20.3573 7.22476 20.3573 6.86972V4.28544C20.3573 3.9304 20.0694 3.64258 19.7144 3.64258Z"
    //         stroke={fill}
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M9.42878 3.64258H4.28592C3.93088 3.64258 3.64307 3.9304 3.64307 4.28544V11.9997C3.64307 12.3548 3.93088 12.6426 4.28592 12.6426H9.42878C9.78382 12.6426 10.0716 12.3548 10.0716 11.9997V4.28544C10.0716 3.9304 9.78382 3.64258 9.42878 3.64258Z"
    //         stroke={fill}
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //       <path
    //         d="M9.42878 16.4873H4.28592C3.93088 16.4873 3.64307 16.775 3.64307 17.1302V19.7144C3.64307 20.0694 3.93088 20.3573 4.28592 20.3573H9.42878C9.78382 20.3573 10.0716 20.0694 10.0716 19.7144V17.1302C10.0716 16.775 9.78382 16.4873 9.42878 16.4873Z"
    //         stroke={fill}
    //         strokeLinecap="round"
    //         strokeLinejoin="round"
    //       />
    //     </g>
    //   </g>
    //   <defs>
    //     <clipPath id="clip0_3860_4522">
    //       <rect width="24" height="24" fill={fill} />
    //     </clipPath>
    //     <clipPath id="clip1_3860_4522">
    //       <rect width="18" height="18" fill={fill} transform="translate(3 3)" />
    //     </clipPath>
    //   </defs>
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M42.36,9.94c2.75,0,3.3,1.38,3.3,3.52V39.18a2.78,2.78,0,0,1-3.08,3H29.47a2.75,2.75,0,0,1-2.92-3V13.24c0-2.36,1.21-3.3,3.14-3.3ZM20,22.22c2.75,0,3.3,1.38,3.3,3.53V39a2.77,2.77,0,0,1-3.08,3h-12A3,3,0,0,1,5,39V25.53c0-2.37,1.21-3.31,3.14-3.31Zm-1,2.2c1.37,0,2.09.67,2.09,2.15V37.86a1.93,1.93,0,0,1-2,1.93H9.26a2,2,0,0,1-2.09-1.93c0-1.15,0-6.61,0-11.56a1.85,1.85,0,0,1,1.93-1.93h9.91Zm2.64-11.51H6.78c-2.37,0-2.26-2.53,0-2.64H21.7C23.63,10.27,24.07,12.86,21.65,12.91Zm0,5.9H6.78c-2.37-.11-2.31-2.65,0-2.65H21.7C23.63,16.16,24.07,18.75,21.65,18.81Zm19.71-6.67c1.38,0,2.1.66,2.1,2.15V38a1.93,1.93,0,0,1-2,1.92H30.52A1.79,1.79,0,0,1,28.7,38V14a1.85,1.85,0,0,1,1.93-1.93H41.36Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  verfiedIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--primary-button)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.74935 1.6665C4.54102 1.6665 1.91602 4.2915 1.91602 7.49984C1.91602 10.7082 4.54102 13.3332 7.74935 13.3332C10.9577 13.3332 13.5827 10.7082 13.5827 7.49984C13.5827 4.2915 10.9577 1.6665 7.74935 1.6665ZM6.46602 10.5915L4.01602 8.19984L4.83268 7.38317L6.46602 8.95817L10.666 4.8165L11.4827 5.63317L6.46602 10.5915Z"
        fill={fill}
      />
    </svg>
  ),
  shareIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--primary-button)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M9.031 13.359L15.178 16.941M15.169 7.059L9.031 10.641M20.2 5.7C20.2 7.19117 18.9912 8.4 17.5 8.4C16.0088 8.4 14.8 7.19117 14.8 5.7C14.8 4.20883 16.0088 3 17.5 3C18.9912 3 20.2 4.20883 20.2 5.7ZM9.4 12C9.4 13.4912 8.19117 14.7 6.7 14.7C5.20883 14.7 4 13.4912 4 12C4 10.5088 5.20883 9.3 6.7 9.3C8.19117 9.3 9.4 10.5088 9.4 12ZM20.2 18.3C20.2 19.7912 18.9912 21 17.5 21C16.0088 21 14.8 19.7912 14.8 18.3C14.8 16.8088 16.0088 15.6 17.5 15.6C18.9912 15.6 20.2 16.8088 20.2 18.3Z"
    //     stroke={`${fill}`}
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M33.64,39.05,17,29.29a.25.25,0,0,1-.19.06,4.24,4.24,0,0,1-2,.43,4.48,4.48,0,1,1,0-9,4.09,4.09,0,0,1,2.24.62l16.35-9.57a2.65,2.65,0,0,1-.06-.68,3.36,3.36,0,1,1,3.35,3.35,3.52,3.52,0,0,1-2.11-.74L18.66,23a4.4,4.4,0,0,1,.68,2.36,4.72,4.72,0,0,1-.62,2.3l16.1,9.26a3.27,3.27,0,0,1,2.18-.8,3.36,3.36,0,0,1,0,6.71,3.1,3.1,0,0,1-1.68-.5c0,.13,0,.13-.13-.06a3.3,3.3,0,0,1-1.49-2.8v-.43Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  filterIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--primary-button)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1001 16C13.6524 16 14.1001 16.4477 14.1001 17C14.1001 17.5523 13.6524 18 13.1001 18H11.1001C10.5478 18 10.1001 17.5523 10.1001 17C10.1001 16.4477 10.5478 16 11.1001 16H13.1001ZM15.1001 11C15.6524 11 16.1001 11.4477 16.1001 12C16.1001 12.5523 15.6524 13 15.1001 13H9.1001C8.54781 13 8.1001 12.5523 8.1001 12C8.1001 11.4477 8.54781 11 9.1001 11H15.1001ZM18.1001 6C18.6524 6 19.1001 6.44772 19.1001 7C19.1001 7.55228 18.6524 8 18.1001 8H6.1001C5.54781 8 5.1001 7.55228 5.1001 7C5.1001 6.44772 5.54781 6 6.1001 6H18.1001Z"
        fill={fill}
      />
    </svg>
  ),
  editIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M13.8765 5.69458C14.196 5.37506 14.7142 5.37506 15.0337 5.69458L18.3062 8.96704C18.6256 9.28657 18.6256 9.80479 18.3062 10.1243L8.89697 19.5334C8.79631 19.6341 8.671 19.7069 8.53369 19.7444L4.03369 20.9709C3.75043 21.0482 3.44736 20.9676 3.23975 20.76C3.03243 20.5525 2.9518 20.2501 3.02881 19.967L4.25635 15.467C4.2938 15.3297 4.36667 15.2044 4.46729 15.1038L13.8765 5.69458ZM5.77783 16.1067L4.98486 19.0159L7.89307 18.2229L16.5708 9.54517L14.4546 7.42993L5.77783 16.1067ZM16.3306 3.2395C16.6501 2.92002 17.1683 2.92007 17.4878 3.2395L20.7603 6.51196C21.0798 6.83148 21.0798 7.34967 20.7603 7.66919C20.4407 7.98871 19.9225 7.98871 19.603 7.66919L16.3306 4.39673C16.0111 4.0772 16.0111 3.55899 16.3306 3.2395Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M18,40.76a1.67,1.67,0,0,1-1.39.57c-1.22,0-2,.09-2.78.09s-1.39.08-2.53.08a2.21,2.21,0,0,1-1.72-.57A2.25,2.25,0,0,1,9,39.29c0-1.8.09-3.6.09-5.32a2.4,2.4,0,0,1,.16-.73,1.85,1.85,0,0,1,.41-.66L17.24,25c2.7-2.86,5.56-5.64,8.34-8.34l4,4,4.17,4.17c-5.32,5.32-10.63,10.72-15.95,16Zm7-13.58c-3.27,3.36-6,6.06-9.16,9.25-1.48,1.47-3-.17-1.64-1.64.57-.57,6.63-6.71,9.16-9.33,1.15-1.22,3,.17,1.64,1.64Zm6.13-2.45L28.36,22l-2.62-2.62c-5.23,5.24-6,6.13-6.87,7-1.47,1.48-7,7-7.6,7.69A16.89,16.89,0,0,1,11.18,36c0,1.06-.08,2.29-.08,3.27,0,.33,0,.25.25.25,1,0,1.71-.09,2.45-.09.9-.08,1.88-.08,2.78-.08C21.41,34.55,26.24,29.64,31.14,24.73Zm8-5.4-3.44,3.44L35,23.5l-.74-.73c-1.31-1.31-3-3.11-4.58-4.67l-2.86-2.86c.82-.82,1.63-1.64,2.53-2.45l1.8-1.8a2,2,0,0,1,1.56-.58,1.92,1.92,0,0,1,1.47.66l5.07,5.07a2.2,2.2,0,0,1,.66,1.72A2.59,2.59,0,0,1,39.16,19.33Zm-2.37-.49,1-1c.16-.17.16-.25,0-.41-1.64-1.72-3.35-3.36-5.07-5.07a.24.24,0,0,0-.33,0l-2.78,2.78,5.4,5.4,1.8-1.8Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  playlistIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M12,15.32c4.61.06,9.16.12,13.77.12s9.17-.06,13.72-.18h0a4.2,4.2,0,0,1,2.77.93,3.78,3.78,0,0,1,1.21,2.59h0V39.53h0a3.65,3.65,0,0,1-1,2.6,3.71,3.71,0,0,1-2.53,1.09c-9.46,0-19-.06-28.48-.06A3.92,3.92,0,0,1,8.62,41.9,4.58,4.58,0,0,1,7.41,39h0V19.13A3.42,3.42,0,0,1,9,16a5.18,5.18,0,0,1,2.88-.75H12ZM10.58,11.4H40a1,1,0,0,1,1,1h0a1,1,0,0,1-1,1H10.58a1,1,0,0,1-1-1h0A1,1,0,0,1,10.58,11.4Zm3.35-3.17H36.29A.79.79,0,0,1,37.1,9h0a.79.79,0,0,1-.81.8H13.93a.78.78,0,0,1-.81-.8h0A.79.79,0,0,1,13.93,8.23Zm9.51,15.91c1.32.87,4.84,3.17,6.63,4.27a1,1,0,0,1,.11,1.73c-2,1.49-4.5,3-6.63,4.38a1.23,1.23,0,0,1-2-.93c0-2.24-.05-6.16-.05-8.47A1.3,1.3,0,0,1,22,24a1.15,1.15,0,0,1,1.38.17Zm2.3-6.74c-4.61,0-9.16-.06-13.77-.12h-.06a3.64,3.64,0,0,0-1.79.4,1.72,1.72,0,0,0-.69,1.5V39a2.39,2.39,0,0,0,.69,1.62,1.9,1.9,0,0,0,1.44.63l28.31.06a2,2,0,0,0,1.26-.52,2,2,0,0,0,.46-1.27V18.78a1.45,1.45,0,0,0-.51-1.1,2.27,2.27,0,0,0-1.5-.46h0c-4.61.12-9.17.18-13.78.18Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  DeleteIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M13.8184 3C14.4692 3.00005 15.0935 3.25856 15.5537 3.71875C16.0139 4.17896 16.2723 4.80328 16.2725 5.4541V6.27246H19.5459C19.9975 6.2727 20.3632 6.63913 20.3633 7.09082C20.3633 7.54254 19.9976 7.90894 19.5459 7.90918H18.7275V18.5459C18.7274 19.1967 18.4689 19.8211 18.0088 20.2812C17.5485 20.7416 16.9234 21 16.2725 21H8.09082C7.43995 21 6.81575 20.7414 6.35547 20.2812C5.89526 19.821 5.63684 19.1967 5.63672 18.5459V7.90918H4.81836C4.36649 7.90918 4 7.54269 4 7.09082C4.00004 6.63898 4.36651 6.27246 4.81836 6.27246H8.09082V5.4541C8.09094 4.80329 8.34938 4.17896 8.80957 3.71875C9.26989 3.25843 9.89491 3 10.5459 3H13.8184ZM7.27246 18.5459C7.27258 18.7627 7.35936 18.9707 7.5127 19.124C7.6661 19.2773 7.87394 19.3633 8.09082 19.3633H16.2725C16.4895 19.3633 16.6981 19.2775 16.8516 19.124C17.0048 18.9707 17.0907 18.7627 17.0908 18.5459V7.90918H7.27246V18.5459ZM10.5459 10.3633C10.9975 10.3635 11.3632 10.73 11.3633 11.1816V16.0908C11.3633 16.5425 10.9976 16.9089 10.5459 16.9092C10.094 16.9092 9.72754 16.5427 9.72754 16.0908V11.1816C9.72764 10.7299 10.0941 10.3633 10.5459 10.3633ZM13.8184 10.3633C14.2701 10.3634 14.6366 10.7299 14.6367 11.1816V16.0908C14.6367 16.5426 14.2701 16.9091 13.8184 16.9092C13.3665 16.9092 13 16.5427 13 16.0908V11.1816C13.0001 10.7299 13.3666 10.3633 13.8184 10.3633ZM10.5459 4.63672C10.3289 4.63672 10.1202 4.72254 9.9668 4.87598C9.81349 5.02931 9.72766 5.23729 9.72754 5.4541V6.27246H14.6367V5.4541C14.6366 5.23727 14.5498 5.02931 14.3965 4.87598C14.2431 4.72266 14.0352 4.63677 13.8184 4.63672H10.5459Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M36.65,18.52c-.42,7.18-1.06,13.84-1.59,20.6A4.57,4.57,0,0,1,34,41.44a3.28,3.28,0,0,1-2.33,1H18.48a3.2,3.2,0,0,1-2.22-.85,3.56,3.56,0,0,1-1-2.22c-.32-3.59-.53-6.55-.74-9.61-.21-3.49-.42-7-.85-11.52V18a3.47,3.47,0,0,1,1.06-2.43,4.15,4.15,0,0,1,2.54-1.05h16A3.08,3.08,0,0,1,36,15.88a3.46,3.46,0,0,1,.63,2.43ZM20.38,23.59c0-1.06.63-1.27,1.16-1.27s1.06.32,1.06,1.27V36.16a1.12,1.12,0,1,1-2.22,0Zm3.7,0c0-1.06.63-1.27,1.16-1.27s1.06.32,1.06,1.27V36.16a1.12,1.12,0,1,1-2.22,0Zm3.7,0c0-1.06.63-1.27,1.16-1.27s1,.32,1,1.27V36.16a1.11,1.11,0,1,1-2.21,0Zm7.81-10.77H14.78c-2.11,0-2.22-2.43,0-2.43h5.07c2.43-2.54,7.93-2.75,10.14,0H35.7c2.43,0,2.43,2.43,0,2.43Zm-.84,5.49c.1-.95-.32-1.8-1.38-1.8H17.42a1.69,1.69,0,0,0-1.16.53,1.34,1.34,0,0,0-.42.95c.42,4.65.63,8.14.95,11.62.21,3,.42,5.92.74,9.62a1.73,1.73,0,0,0,.31,1,1.22,1.22,0,0,0,.85.31h13.1c.84,0,1.27-.74,1.37-1.47.53-6.34,1.06-13.42,1.59-20.5Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  LanguageIcon: ({
    width = '20px',
    height = '20px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M16.0908 11.1816C16.4006 11.1817 16.6836 11.3568 16.8223 11.6338L20.9131 19.8154C21.1151 20.2194 20.9517 20.7109 20.5479 20.9131C20.1438 21.1151 19.6524 20.9517 19.4502 20.5479L18.04 17.7275H14.1416L12.7314 20.5479C12.5293 20.9518 12.0378 21.1151 11.6338 20.9131C11.2298 20.7109 11.0665 20.2195 11.2686 19.8154L15.3594 11.6338C15.498 11.3568 15.7811 11.1816 16.0908 11.1816ZM14.96 16.0908H17.2217L16.0908 13.8291L14.96 16.0908ZM13.6367 5.4541C14.0883 5.45435 14.454 5.82086 14.4541 6.27246C14.4541 6.72417 14.0884 7.09057 13.6367 7.09082H12.4375L11.0439 9.18066C11.0141 9.22543 10.9804 9.26761 10.9424 9.30566L9.47559 10.7725L11.7607 13.0576C12.08 13.3771 12.08 13.8954 11.7607 14.2148C11.4413 14.5343 10.923 14.5342 10.6035 14.2148L8.31836 11.9297L6.0332 14.2148C5.71369 14.5344 5.19549 14.5343 4.87598 14.2148C4.55646 13.8953 4.55646 13.3771 4.87598 13.0576L7.16113 10.7725L5.69434 9.30566C5.37482 8.98615 5.37482 8.46795 5.69434 8.14844C6.01387 7.82916 6.53212 7.829 6.85156 8.14844L8.31836 9.61523L9.72754 8.20605L10.4707 7.09082H3.81836C3.36649 7.09082 3 6.72433 3 6.27246C3.00013 5.8207 3.36657 5.4541 3.81836 5.4541H13.6367ZM8.72754 3C9.17924 3.00019 9.54492 3.36661 9.54492 3.81836C9.54482 4.27002 9.17918 4.63653 8.72754 4.63672H7.90918C7.45738 4.63672 7.09092 4.27014 7.09082 3.81836C7.09082 3.36649 7.45731 3 7.90918 3H8.72754Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M33.14,21.58a2.9,2.9,0,0,1,.83,1L43.1,40.81c.07.07.07.14.13.34a1.15,1.15,0,0,1-1.79,1.11c-.14-.07-.21-.21-.28-.28-.69-1.45-1.59-3-2.42-4.42-.35-.7-.76-1.32-1.18-2H27.4c-1.11,2.08-2.56,4.43-3.53,6.5a1.15,1.15,0,0,1-1,.42,1,1,0,0,1-1-1,.63.63,0,0,1,.07-.35l9.27-18.53c.21-.35.48-.83.83-1a1.1,1.1,0,0,1,1,.07Zm-5,11.76h8.57l-4.28-8.58ZM9,12.87l19.44.07a1.15,1.15,0,0,1,1.1.69,1.17,1.17,0,0,1,0,1,1.15,1.15,0,0,1-1,.76H26c-1.18,1.17-2.15,2.21-3.12,3.25-1.45,1.52-2.83,2.9-4.56,4.77l6.15,6.15a1.1,1.1,0,0,1,.28,1.32,1.36,1.36,0,0,1-.69.69,1.2,1.2,0,0,1-1.25-.28L16.61,25l-5.33,5.6a1.33,1.33,0,0,1-1.31.42,1.17,1.17,0,0,1-.69-.7,1.23,1.23,0,0,1,.35-1.31c1.86-1.8,3.59-3.73,5.39-5.67l-2.28-2.21a1.21,1.21,0,0,1-.28-1.32,1.26,1.26,0,0,1,.69-.62,1.15,1.15,0,0,1,1.25.42l2.21,2,6.15-6.36-13.9.07a1.13,1.13,0,0,1-1.17-.69A1.18,1.18,0,0,1,8.86,13Zm4.57-3.53h5.94a.91.91,0,0,1,.9.62,1,1,0,0,1,0,.9.9.9,0,0,1-.9.62h-6a1,1,0,0,1-1-.62,1.66,1.66,0,0,1,0-.83.93.93,0,0,1,1-.62Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  EyeOn: ({ width = '16px', height = '16px', fill = 'var(--icon-color)', onClick = null }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M12 5C14.9246 5 17.1713 6.6701 18.6406 8.2373C19.3819 9.02804 19.9483 9.81569 20.3291 10.4053C20.52 10.7008 20.6658 10.9492 20.7646 11.125C20.814 11.2128 20.8519 11.2828 20.8779 11.332C20.8909 11.3565 20.9011 11.3758 20.9082 11.3896L20.917 11.4062L20.9209 11.4141C21.0264 11.6252 21.0265 11.8748 20.9209 12.0859L20.25 11.75C20.877 12.0635 20.9174 12.0852 20.9199 12.0869V12.0889L20.917 12.0938L20.9082 12.1104C20.9011 12.1242 20.8909 12.1435 20.8779 12.168C20.8518 12.2173 20.8141 12.288 20.7646 12.376C20.6658 12.5517 20.5199 12.7994 20.3291 13.0947C19.9483 13.6843 19.382 14.4719 18.6406 15.2627C17.1713 16.8299 14.9246 18.5 12 18.5C9.07538 18.5 6.82864 16.8299 5.35938 15.2627C4.61803 14.4719 4.05169 13.6843 3.6709 13.0947C3.48013 12.7993 3.33421 12.5517 3.23535 12.376C3.18589 12.288 3.14816 12.2173 3.12207 12.168C3.10912 12.1435 3.09893 12.1242 3.0918 12.1104L3.08301 12.0938L3.08105 12.0889L3.0791 12.0859C2.97359 11.8749 2.9737 11.6261 3.0791 11.415L3.75 11.75C3.0792 11.4146 3.07994 11.4134 3.08008 11.4131L3.08105 11.4121L3.08301 11.4062L3.0918 11.3896C3.09893 11.3758 3.10912 11.3565 3.12207 11.332C3.14812 11.2828 3.186 11.2127 3.23535 11.125C3.33422 10.9492 3.48003 10.7008 3.6709 10.4053C4.0517 9.81568 4.61804 9.02807 5.35938 8.2373C6.82864 6.67009 9.07538 5.00003 12 5ZM12 6.5C9.67465 6.50003 7.79636 7.82991 6.45312 9.2627C5.78834 9.9718 5.27643 10.6843 4.93066 11.2197C4.79613 11.4281 4.6874 11.6084 4.60547 11.75C4.68739 11.8916 4.79615 12.072 4.93066 12.2803C5.27642 12.8156 5.78836 13.5282 6.45312 14.2373C7.79636 15.6701 9.67464 17 12 17C14.3254 17 16.2036 15.6701 17.5469 14.2373C18.2117 13.5282 18.7236 12.8157 19.0693 12.2803C19.2039 12.072 19.3126 11.8916 19.3945 11.75C19.3126 11.6084 19.2039 11.4281 19.0693 11.2197C18.7236 10.6843 18.2117 9.9718 17.5469 9.2627C16.2036 7.82993 14.3253 6.5 12 6.5ZM12 8.75C13.6568 8.75 14.9999 10.0932 15 11.75C15 13.4069 13.6569 14.75 12 14.75C10.3432 14.7499 9 13.4068 9 11.75C9.00006 10.0932 10.3433 8.75009 12 8.75ZM12 10.25C11.1717 10.2501 10.5001 10.9217 10.5 11.75C10.5 12.5784 11.1716 13.2499 12 13.25C12.8284 13.25 13.5 12.5784 13.5 11.75C13.4999 10.9216 12.8284 10.25 12 10.25Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M44.91,27.33a20,20,0,0,1-8,8.77A21.74,21.74,0,0,1,26.64,39,23.54,23.54,0,0,1,16,36.74a22.31,22.31,0,0,1-9.76-8.9,3.74,3.74,0,0,1-.69-2.35,4.63,4.63,0,0,1,.86-2.4,23.88,23.88,0,0,1,8.17-8.35,21.47,21.47,0,0,1,10.83-3.08,21.11,21.11,0,0,1,11,2.91,24,24,0,0,1,8.34,8.48l.09.17a7.38,7.38,0,0,1,.47,2,4.45,4.45,0,0,1-.34,2l-.05,0ZM25.74,18.6A6.76,6.76,0,1,1,19,25.36,6.77,6.77,0,0,1,25.74,18.6ZM35.93,34.39a18.13,18.13,0,0,0,7.14-7.88,3.09,3.09,0,0,0,.22-1.2A6.89,6.89,0,0,0,43,24a22,22,0,0,0-7.62-7.71,18.94,18.94,0,0,0-9.93-2.65,19.13,19.13,0,0,0-9.8,2.83,21.76,21.76,0,0,0-7.49,7.66l0,.08a2.58,2.58,0,0,0-.51,1.37A1.9,1.9,0,0,0,8,26.77l0,.09a20.4,20.4,0,0,0,8.86,8.08A21.38,21.38,0,0,0,26.6,37,19.32,19.32,0,0,0,35.93,34.39Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  EyeOff: ({ width = '16px', height = '16px', fill = 'var(--icon-color)', onClick = null }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M3.21973 3.21973C3.51262 2.92683 3.98738 2.92683 4.28027 3.21973L20.7803 19.7197C21.0732 20.0126 21.0732 20.4874 20.7803 20.7803C20.4874 21.0732 20.0126 21.0732 19.7197 20.7803L16.3691 17.4297C15.0719 18.2646 13.5639 18.7246 12.0127 18.75H12C9.07537 18.75 6.82864 17.0799 5.35938 15.5127C4.61803 14.7219 4.05169 13.9343 3.6709 13.3447C3.48012 13.0493 3.33421 12.8017 3.23535 12.626C3.18589 12.538 3.14816 12.4673 3.12207 12.418C3.10912 12.3935 3.09892 12.3742 3.0918 12.3604L3.08301 12.3438L3.08105 12.3389L3.08008 12.3369C3.08217 12.3357 3.11837 12.3158 3.75 12L3.0791 12.3359C2.97014 12.118 2.97372 11.8602 3.08887 11.6455C3.93753 10.064 5.07011 8.65506 6.42676 7.4873L3.21973 4.28027C2.92683 3.98738 2.92683 3.51262 3.21973 3.21973ZM7.49023 8.55078C6.33765 9.52583 5.36153 10.6942 4.60645 12.0029C4.6882 12.1441 4.79695 12.3232 4.93066 12.5303C5.27642 13.0656 5.78837 13.7782 6.45312 14.4873C7.79518 15.9188 9.6716 17.2477 11.9941 17.25C13.1531 17.23 14.2826 16.9139 15.2783 16.3389L13.5371 14.5977C13.418 14.6723 13.294 14.7394 13.165 14.7969C12.7971 14.9608 12.3998 15.0485 11.9971 15.0557C11.5943 15.0628 11.1939 14.9888 10.8203 14.8379C10.4468 14.687 10.1071 14.4626 9.82227 14.1777C9.53741 13.8929 9.31299 13.5532 9.16211 13.1797C9.01125 12.8062 8.93723 12.4057 8.94434 12.0029C8.95149 11.6002 9.03921 11.2028 9.20312 10.835C9.26058 10.706 9.32771 10.5819 9.40234 10.4629L7.49023 8.55078ZM12.001 5.25C14.9251 5.25042 17.1715 6.92029 18.6406 8.4873C19.382 9.27807 19.9483 10.0657 20.3291 10.6553C20.5199 10.9507 20.6658 11.1983 20.7646 11.374L20.9209 11.665C21.0295 11.8825 21.0257 12.1391 20.9111 12.3535C20.4313 13.2511 19.8594 14.0962 19.2041 14.875C18.9375 15.1918 18.4644 15.233 18.1475 14.9668C17.8305 14.7001 17.789 14.2261 18.0557 13.9092C18.5574 13.3129 19.0055 12.6733 19.3936 11.998C19.3118 11.8567 19.2033 11.6771 19.0693 11.4697C18.7236 10.9344 18.2116 10.2218 17.5469 9.5127C16.2037 8.07993 14.3253 6.75004 12 6.75H11.998C11.526 6.7489 11.0553 6.80257 10.5957 6.91016C10.1924 7.00451 9.78873 6.75387 9.69434 6.35059C9.60021 5.94746 9.85081 5.54463 10.2539 5.4502C10.8265 5.31617 11.4129 5.24869 12.001 5.25ZM10.5205 11.582C10.4725 11.7261 10.4471 11.8769 10.4443 12.0293C10.4408 12.2307 10.4773 12.4314 10.5527 12.6182C10.6282 12.8049 10.7404 12.9748 10.8828 13.1172C11.0252 13.2596 11.1951 13.3718 11.3818 13.4473C11.5686 13.5227 11.7693 13.5592 11.9707 13.5557C12.1231 13.5529 12.2739 13.5275 12.418 13.4795L10.5205 11.582Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M44.81,27.8a20,20,0,0,1-8,8.76,21.77,21.77,0,0,1-10.34,2.89,23.25,23.25,0,0,1-10.6-2.26c-.16,0-.26-.15-.42-.21l1.68-1.41a21.11,21.11,0,0,0,9.29,1.83,19.34,19.34,0,0,0,9.34-2.62,18.06,18.06,0,0,0,7.14-7.87,3.63,3.63,0,0,0,.21-1.21,4.24,4.24,0,0,0-.32-1.31,23.33,23.33,0,0,0-5-5.93l1.58-1.31a26.16,26.16,0,0,1,5.25,6.29l.1.16a6.86,6.86,0,0,1,.47,2,4.1,4.1,0,0,1-.36,2.05l-.06.05Zm-3.1-14.38C37.62,16.83,14,36.35,10,39.71c-1.83,1.47-3.36-.52-1.68-2l3.52-2.94a22.22,22.22,0,0,1-5.67-6.4A3.71,3.71,0,0,1,5.5,26a4.58,4.58,0,0,1,.84-2.41,23.9,23.9,0,0,1,8.19-8.34,21.52,21.52,0,0,1,10.81-3.1,21,21,0,0,1,10.54,2.68l4.2-3.47C41.55,10.17,43.55,11.85,41.71,13.42Zm-28.29,20,6-5a6.48,6.48,0,0,1-.53-2.63A6.79,6.79,0,0,1,25.65,19a6.65,6.65,0,0,1,3.78,1.16l4.83-4a19.82,19.82,0,0,0-8.87-2.1,19.48,19.48,0,0,0-9.82,2.84,21.46,21.46,0,0,0-7.5,7.66l-.05,0A2.43,2.43,0,0,0,7.49,26a2.08,2.08,0,0,0,.37,1.21l0,.05a20.49,20.49,0,0,0,5.51,6.09ZM32,23.39a7.39,7.39,0,0,1,.42,2.41,6.79,6.79,0,0,1-6.77,6.77,6.58,6.58,0,0,1-3.52-1l9.82-8.14Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  ArrowIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     fillRule="evenodd"
    //     clipRule="evenodd"
    //     d="M15.7071 5.29289C16.0976 5.68342 16.0976 6.31658 15.7071 6.70711L10.4142 12L15.7071 17.2929C16.0976 17.6834 16.0976 18.3166 15.7071 18.7071C15.3166 19.0976 14.6834 19.0976 14.2929 18.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929L14.2929 5.29289C14.6834 4.90237 15.3166 4.90237 15.7071 5.29289Z"
    //     fill={fill}
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M17.18,24.74c6.05-6.12,8.37-8.54,14.42-14.58,1.9-1.71,3,.83,1.85,1.83L20,25.57c4.41,4.36,9,8.86,13.31,13.22,1.92,1.76-.12,3.75-1.83,2.14L17.12,26.72a1.31,1.31,0,0,1,0-2Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  helpIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 2C11.3137 2 14 4.68629 14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2ZM8 3.09082C5.28878 3.09082 3.09082 5.28878 3.09082 8C3.09082 10.7112 5.28878 12.9092 8 12.9092C10.7112 12.9092 12.9092 10.7112 12.9092 8C12.9092 5.28878 10.7112 3.09082 8 3.09082ZM8 7.45508C8.30103 7.45532 8.5449 7.69892 8.54492 8V10.1816C8.54492 10.4827 8.30104 10.7273 8 10.7275C7.69875 10.7275 7.4541 10.4829 7.4541 10.1816V8C7.45413 7.69877 7.69877 7.45508 8 7.45508ZM8.00488 5.27246C8.30613 5.27246 8.55078 5.51711 8.55078 5.81836C8.55067 6.11951 8.30606 6.36328 8.00488 6.36328H8C7.69882 6.36328 7.45421 6.11951 7.4541 5.81836C7.4541 5.51711 7.69875 5.27246 8 5.27246H8.00488Z"
        fill={fill}
      />
    </svg>
  ),
  uploadIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M20 14.6667V18.2223C20 18.6938 19.8127 19.146 19.4793 19.4794C19.1459 19.8128 18.6937 20.0001 18.2222 20.0001H5.77778C5.30628 20.0001 4.8541 19.8128 4.5207 19.4794C4.1873 19.146 4 18.6938 4 18.2223V14.6667"
    //     stroke={fill}
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M16.4446 8.44444L12.0001 4L7.55566 8.44444"
    //     stroke={fill}
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    //   <path
    //     d="M12 4V14.6667"
    //     stroke={fill}
    //     strokeWidth="1.5"
    //     strokeLinecap="round"
    //     strokeLinejoin="round"
    //   />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M12.31,40.11A4.2,4.2,0,0,1,9.23,38.8a4.32,4.32,0,0,1-1.31-3V26.88a1.12,1.12,0,1,1,2.22,0v9a2.65,2.65,0,0,0,1.87,2H38.82a2.21,2.21,0,0,0,1.92-2.07V26.88a1.13,1.13,0,1,1,2.23,0v8.84a4.4,4.4,0,0,1-4.4,4.39ZM23.63,11.53c-2.78,2.83-2,2-4.75,4.85-1.92,2,.81,4.54,2.83,2.37l2.62-2.63V30.06c.05,2.53,2.58,2.53,2.53,0V16.17c1,1,1.82,1.72,2.72,2.58,1.87,2,4.55-.4,2.58-2.58l-4.95-4.69L27,11.23a2,2,0,0,0-2.88-.1,4.51,4.51,0,0,1-.5.45Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  // editIcon: ({
  //   width = '16px',
  //   height = '16px',
  //   fill = 'var(--icon-color)',
  //   onClick = null,
  //   className = '',
  // }) => (
  //   <svg
  //     onClick={onClick}
  //     width={width}
  //     height={height}
  //     className={className}
  //     viewBox="0 0 18 18"
  //     fill="none"
  //     xmlns="http://www.w3.org/2000/svg"
  //   >
  //     <path
  //       d="M10.876 2.69458C11.1955 2.37506 11.7137 2.37506 12.0332 2.69458L15.3057 5.96704C15.6252 6.28656 15.6252 6.80475 15.3057 7.12427L5.89648 16.5334C5.79586 16.634 5.67043 16.707 5.5332 16.7444L1.0332 17.9709C0.750227 18.048 0.447753 17.9682 0.240234 17.761C0.0326806 17.5534 -0.0478439 17.2502 0.0292969 16.967L1.25586 12.467C1.29328 12.3298 1.36628 12.2044 1.4668 12.1038L10.876 2.69458ZM2.77832 13.1067L1.98438 16.0159L4.89355 15.2229L13.5703 6.54517L11.4551 4.42993L2.77832 13.1067ZM13.3311 0.239502C13.6506 -0.0797169 14.1689 -0.0799173 14.4883 0.239502L17.7607 3.51294C18.0799 3.83238 18.0799 4.34975 17.7607 4.66919C17.4412 4.98871 16.923 4.98871 16.6035 4.66919L13.3311 1.39673C13.0115 1.07721 13.0115 0.559021 13.3311 0.239502Z"
  //       fill={fill}
  //     />
  //   </svg>
  // ),
  deleteIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M36.65,18.52c-.42,7.18-1.06,13.84-1.59,20.6A4.57,4.57,0,0,1,34,41.44a3.28,3.28,0,0,1-2.33,1H18.48a3.2,3.2,0,0,1-2.22-.85,3.56,3.56,0,0,1-1-2.22c-.32-3.59-.53-6.55-.74-9.61-.21-3.49-.42-7-.85-11.52V18a3.47,3.47,0,0,1,1.06-2.43,4.15,4.15,0,0,1,2.54-1.05h16A3.08,3.08,0,0,1,36,15.88a3.46,3.46,0,0,1,.63,2.43ZM20.38,23.59c0-1.06.63-1.27,1.16-1.27s1.06.32,1.06,1.27V36.16a1.12,1.12,0,1,1-2.22,0Zm3.7,0c0-1.06.63-1.27,1.16-1.27s1.06.32,1.06,1.27V36.16a1.12,1.12,0,1,1-2.22,0Zm3.7,0c0-1.06.63-1.27,1.16-1.27s1,.32,1,1.27V36.16a1.11,1.11,0,1,1-2.21,0Zm7.81-10.77H14.78c-2.11,0-2.22-2.43,0-2.43h5.07c2.43-2.54,7.93-2.75,10.14,0H35.7c2.43,0,2.43,2.43,0,2.43Zm-.84,5.49c.1-.95-.32-1.8-1.38-1.8H17.42a1.69,1.69,0,0,0-1.16.53,1.34,1.34,0,0,0-.42.95c.42,4.65.63,8.14.95,11.62.21,3,.42,5.92.74,9.62a1.73,1.73,0,0,0,.31,1,1.22,1.22,0,0,0,.85.31h13.1c.84,0,1.27-.74,1.37-1.47.53-6.34,1.06-13.42,1.59-20.5Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  MiceIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="6" height="1" rx="0.5" transform="matrix(1 0 0 -1 5 16)" fill={fill} />
      <rect width="2" height="2" transform="matrix(1 0 0 -1 7 15)" fill={fill} />
      <path
        d="M3.5 6.5V8.5C3.5 10.7091 5.29086 12.5 7.5 12.5H8.5C10.7091 12.5 12.5 10.7091 12.5 8.5V6.5"
        stroke={fill}
        strokeLinecap="round"
      />
      <rect x="5.5" y="0.5" width="5" height="10" rx="2.5" stroke={fill} />
    </svg>
  ),
  filterSearchIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.0760054 0.473827C0.210071 0.184875 0.499653 0 0.818192 0H17.1818C17.5003 0 17.7899 0.184875 17.924 0.473827C18.0581 0.76278 18.0122 1.10327 17.8065 1.3465L11.4545 8.85775V15.5454C11.4545 15.829 11.3077 16.0923 11.0665 16.2414C10.8253 16.3905 10.5241 16.4041 10.2705 16.2772L6.99774 14.6409C6.72055 14.5023 6.54546 14.219 6.54546 13.9091V8.85775L0.193453 1.3465C-0.0122352 1.10327 -0.0580603 0.76278 0.0760054 0.473827ZM2.58162 1.63636L7.98838 8.02985C8.11328 8.17755 8.18182 8.36473 8.18182 8.55817V13.4034L9.81818 14.2216V8.55817C9.81818 8.36473 9.88672 8.17755 10.0116 8.02985L15.4184 1.63636H2.58162Z"
        fill={fill}
      />
    </svg>
  ),
  starIcon: ({
    width = '20px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.6709 0.571289C9.88052 0.571289 10.0868 0.628933 10.2656 0.738281C10.4442 0.847568 10.5891 1.00408 10.6846 1.19043L10.6865 1.19434L12.626 5.03613L16.3115 5.40137C16.5243 5.42022 16.7276 5.49923 16.8975 5.62891C17.069 5.75994 17.1996 5.9378 17.2734 6.14062C17.3473 6.34354 17.3617 6.5637 17.3145 6.77441C17.2672 6.98508 17.1602 7.17811 17.0068 7.33008L13.9492 10.3604L15.084 14.4814C15.14 14.6925 15.1339 14.9153 15.0664 15.123C14.9988 15.331 14.8719 15.5154 14.7021 15.6533C14.5325 15.7911 14.3267 15.8768 14.1094 15.9004C13.8928 15.9239 13.6743 15.8845 13.4795 15.7871L13.4775 15.7861L9.6709 13.9014L5.87109 15.7842L5.86914 15.7852C5.67428 15.8827 5.45493 15.922 5.23828 15.8984C5.021 15.8748 4.81515 15.7882 4.64551 15.6504C4.47595 15.5126 4.34986 15.3289 4.28223 15.1211C4.21458 14.9131 4.20853 14.6899 4.26465 14.4785L4.26562 14.4727L5.39844 10.3584L2.33887 7.32715C2.1855 7.17515 2.07847 6.98219 2.03125 6.77148C1.98412 6.56094 1.99853 6.34144 2.07227 6.13867C2.14611 5.93576 2.27665 5.75804 2.44824 5.62695C2.61819 5.49717 2.82126 5.41827 3.03418 5.39941L6.71973 5.03418L8.65723 1.19043C8.75274 1.00389 8.89838 0.847625 9.07715 0.738281C9.25589 0.628993 9.4614 0.571352 9.6709 0.571289ZM1.92871 10.5586C2.20799 10.5586 2.43457 10.7852 2.43457 11.0645V11.9805H3.35059C3.62985 11.9805 3.85634 12.2071 3.85645 12.4863C3.85645 12.7657 3.62991 12.9922 3.35059 12.9922H2.43457V13.9092C2.43449 14.1884 2.20795 14.415 1.92871 14.415C1.64943 14.415 1.42293 14.1884 1.42285 13.9092V12.9922H0.505859C0.226533 12.9922 0 12.7657 0 12.4863C0.000102787 12.2071 0.226597 11.9805 0.505859 11.9805H1.42285V11.0645C1.42285 10.7851 1.64938 10.5586 1.92871 10.5586ZM18.0723 8.80957C18.3515 8.80962 18.578 9.03626 18.5781 9.31543V10.2324H19.4941C19.7735 10.2324 20 10.459 20 10.7383C19.9999 11.0175 19.7734 11.2441 19.4941 11.2441H18.5781V12.1602C18.5781 12.4395 18.3515 12.666 18.0723 12.666C17.7929 12.666 17.5664 12.4395 17.5664 12.1602V11.2441H16.6494C16.3701 11.2441 16.1436 11.0175 16.1436 10.7383C16.1436 10.459 16.3701 10.2324 16.6494 10.2324H17.5664V9.31543C17.5666 9.03623 17.793 8.80957 18.0723 8.80957ZM3.35059 0C3.62991 0 3.85645 0.226533 3.85645 0.505859V1.42285H4.77344C5.05276 1.42285 5.2793 1.64938 5.2793 1.92871C5.27905 2.20782 5.05261 2.43359 4.77344 2.43359H3.85645V3.35059C3.85645 3.62991 3.62991 3.85645 3.35059 3.85645C3.07131 3.85639 2.84473 3.62988 2.84473 3.35059V2.43359H1.92871C1.64954 2.43359 1.4231 2.20782 1.42285 1.92871C1.42285 1.64938 1.64938 1.42285 1.92871 1.42285H2.84473V0.505859C2.84473 0.226568 3.07131 5.60334e-05 3.35059 0Z"
        fill={fill}
      />
    </svg>
  ),
  ArrowIconLong: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.00459 11.6175C3.95605 11.7345 3.92911 11.8628 3.92871 11.9973L3.92871 12.0033C3.92947 12.2582 4.0271 12.5129 4.2216 12.7074L11.2927 19.7784C11.6832 20.169 12.3164 20.169 12.7069 19.7784C13.0974 19.3879 13.0974 18.7548 12.7069 18.3642L7.34292 13.0003H19.0708C19.6231 13.0003 20.0708 12.5526 20.0708 12.0003C20.0708 11.448 19.6231 11.0003 19.0708 11.0003L7.34292 11.0003L12.7069 5.63631C13.0974 5.24578 13.0974 4.61262 12.7069 4.22209C12.3164 3.83157 11.6832 3.83157 11.2927 4.22209L4.22209 11.2927L4.21948 11.2953C4.12466 11.3907 4.05303 11.5004 4.00459 11.6175Z"
        fill={fill}
      />
    </svg>
  ),
  checkedIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--link-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="24" height="24" rx="2" fill={fill} />
      <path
        d="M19 7.6383L17.4833 6L10.3333 13.7234L7.51667 10.6809L6 12.3191L10.3333 17L19 7.6383Z"
        fill="#F4F4F4"
      />
    </svg>
  ),
  logoutIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.45 19.3C18.6755 19.3 18.8917 19.2104 19.0511 19.051C19.2105 18.8916 19.3 18.6754 19.3 18.45L19.3 6.55C19.3 6.32457 19.2105 6.10837 19.0511 5.94896C18.8917 5.78955 18.6755 5.7 18.45 5.7L15.05 5.7C14.5806 5.7 14.2 5.31944 14.2 4.85C14.2 4.38056 14.5806 4 15.05 4L18.45 4C19.1263 4 19.7749 4.26866 20.2531 4.74688C20.7314 5.2251 21 5.8737 21 6.55V18.45C21 19.1263 20.7314 19.7749 20.2531 20.2531C19.7749 20.7313 19.1263 21 18.45 21H15.05C14.5806 21 14.2 20.6194 14.2 20.15C14.2 19.6806 14.5806 19.3 15.05 19.3H18.45Z"
        fill={fill}
      />
      <path
        d="M9.70105 17.351C9.36911 17.683 8.83092 17.683 8.49897 17.351L4.25162 13.1037C4.24262 13.0948 4.23381 13.0856 4.22521 13.0763C4.15851 13.0041 4.10662 12.9231 4.06955 12.8373C4.0248 12.7339 4 12.6198 4 12.5C4 12.38 4.02488 12.2657 4.06976 12.1622C4.10647 12.0773 4.15768 11.9972 4.22337 11.9257C4.2326 11.9156 4.24206 11.9058 4.25175 11.8962L8.49897 7.64895C8.83092 7.31701 9.36911 7.31701 9.70105 7.64895C10.033 7.9809 10.033 8.51909 9.70105 8.85104L6.90209 11.65L15.05 11.65C15.5194 11.65 15.9 12.0306 15.9 12.5C15.9 12.9694 15.5194 13.35 15.05 13.35H6.90209L9.70105 16.149C10.033 16.4809 10.033 17.0191 9.70105 17.351Z"
        fill={fill}
      />
    </svg>
  ),
  settingIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.92913 12C8.92913 13.8082 10.3937 15.2727 12.2019 15.2727C14.0019 15.2727 15.4746 13.8082 15.4746 12C15.4746 10.1918 14.01 8.72729 12.2019 8.72729C10.3937 8.72729 8.92913 10.1918 8.92913 12ZM10.5655 12C10.5655 11.1 11.3019 10.3637 12.2019 10.3637C13.1019 10.3637 13.8382 11.1 13.8382 12C13.8382 12.9 13.1019 13.6364 12.2019 13.6364C11.3019 13.6364 10.5655 12.9 10.5655 12Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0218 21H12.3818C13.0364 21 13.65 20.7464 14.1245 20.28C14.5909 19.8136 14.8445 19.2 14.8445 18.5455V18.39C14.8445 18.2427 14.8773 18.1036 14.9509 17.9809C15.0245 17.8582 15.1227 17.7518 15.2536 17.6782L15.6055 17.4736C15.8591 17.3345 16.1536 17.3182 16.4482 17.49L16.5464 17.5391C17.1027 17.8582 17.7818 17.9482 18.4036 17.7845C19.0418 17.6209 19.5655 17.2118 19.9009 16.6391L20.0727 16.3282C20.4 15.7636 20.49 15.1009 20.3182 14.4709C20.1464 13.8409 19.7373 13.3091 19.1482 12.9655L19.05 12.9164C18.9191 12.8427 18.8209 12.7364 18.7473 12.6136C18.6818 12.4827 18.6409 12.3436 18.6409 12.1964V11.7873C18.6327 11.6482 18.6736 11.5009 18.7473 11.3782C18.8209 11.2555 18.9191 11.1573 19.0582 11.0755L19.1809 10.9936C19.7455 10.6664 20.1464 10.1345 20.3182 9.50455C20.49 8.87455 20.4 8.21182 20.0727 7.64727L19.8927 7.33636C19.5655 6.77182 19.0336 6.37091 18.4036 6.19909C17.7736 6.02727 17.1027 6.11727 16.5627 6.42818L16.4155 6.51C16.1618 6.64909 15.8427 6.64909 15.5973 6.51L15.2455 6.30545C15.1145 6.24 15.0164 6.13364 14.9427 6.01091C14.8773 5.88818 14.8364 5.74091 14.8364 5.60182V5.45455C14.8364 4.8 14.5827 4.18636 14.1164 3.72C13.65 3.25364 13.0364 3 12.3818 3H12.0218C11.3673 3 10.7455 3.25364 10.2873 3.72C9.82091 4.18636 9.56727 4.8 9.56727 5.45455V5.60182C9.56727 5.74091 9.52636 5.88818 9.46091 6.01091C9.38727 6.13364 9.28091 6.24 9.15818 6.31364L8.80636 6.51C8.55273 6.65727 8.25818 6.67364 7.95545 6.50182L7.85727 6.45273C7.29273 6.12545 6.63 6.03545 6 6.20727C5.37818 6.37091 4.83 6.78818 4.51091 7.34455L4.33091 7.65545C4.00364 8.22 3.92182 8.88273 4.08545 9.51273C4.25727 10.1509 4.65818 10.6745 5.19 10.9855L5.35364 11.0918C5.47636 11.1573 5.58273 11.2636 5.64 11.3782C5.70545 11.5009 5.74636 11.64 5.74636 11.7791V12.2045C5.74636 12.3436 5.71364 12.4909 5.64 12.6136C5.56636 12.7445 5.46818 12.8427 5.32909 12.9245L5.22273 12.99C4.65818 13.3173 4.25727 13.8491 4.08545 14.4791C3.91364 15.1173 4.00364 15.7718 4.33091 16.3445L4.51909 16.6473C4.83818 17.2118 5.38636 17.6209 6.00818 17.7927C6.63818 17.9645 7.30091 17.8745 7.84091 17.5636L7.98818 17.4818C8.24182 17.3427 8.56091 17.3427 8.80636 17.4818L9.15818 17.6864C9.28909 17.76 9.38727 17.8664 9.46091 17.9891C9.52636 18.1118 9.56727 18.2591 9.56727 18.3982V18.5455C9.56727 19.2 9.82091 19.8136 10.2873 20.28C10.7536 20.7464 11.3673 21 12.0218 21ZM9.62455 16.0664C9.24818 15.8536 8.83091 15.7391 8.39727 15.7391C7.96364 15.7391 7.53818 15.8536 7.20273 16.0582L7.05545 16.14C6.86727 16.2464 6.64636 16.2791 6.43364 16.2218C6.22091 16.1645 6.04091 16.0255 5.93455 15.8373L5.75455 15.5264C5.64818 15.3382 5.61545 15.1173 5.67273 14.9045C5.73 14.6918 5.86091 14.5118 6.06545 14.3973L6.17182 14.3318C6.54818 14.1191 6.85909 13.8082 7.07182 13.4318C7.29273 13.0555 7.39909 12.63 7.39909 12.2045V11.7791C7.39909 11.3536 7.27636 10.9364 7.06364 10.56C6.85091 10.1836 6.54 9.88091 6.21273 9.69273L6.04909 9.58636C5.86091 9.48 5.72182 9.30818 5.66455 9.09545C5.61545 8.88273 5.64 8.66182 5.74636 8.47364L5.93455 8.16273C6.04091 7.97455 6.22091 7.83545 6.42545 7.78636C6.63818 7.72909 6.85909 7.75364 7.07182 7.87636L7.17 7.92545C7.90636 8.35909 8.87182 8.35909 9.62455 7.92545L9.97636 7.72909C10.3527 7.50818 10.6636 7.19727 10.8764 6.82909C11.0891 6.45273 11.2036 6.03545 11.2036 5.60182V5.45455C11.2036 5.24182 11.2936 5.02909 11.4409 4.87364C11.5964 4.72636 11.8091 4.63636 12.0218 4.63636H12.3818C12.5945 4.63636 12.8073 4.72636 12.9627 4.87364C13.11 5.02909 13.2 5.24182 13.2 5.45455V5.61C13.2 6.03545 13.3145 6.46091 13.5273 6.83727C13.74 7.20545 14.0509 7.51636 14.4191 7.72909L14.7709 7.93364C15.5155 8.36727 16.5055 8.35909 17.2009 7.95L17.3482 7.86818C17.5364 7.76182 17.7655 7.72909 17.97 7.78636C18.1827 7.84364 18.3627 7.97455 18.4691 8.16273L18.6491 8.47364C18.7555 8.66182 18.7882 8.89091 18.7309 9.09545C18.6736 9.3 18.5427 9.48 18.3464 9.59455L18.2318 9.66C17.8555 9.87273 17.5445 10.1836 17.3318 10.56C17.1191 10.9282 17.0045 11.3618 17.0045 11.7873V12.1964C17.0045 12.6218 17.1191 13.0473 17.3318 13.4236C17.5445 13.8 17.8555 14.1109 18.2564 14.34L18.3545 14.3891C18.5427 14.4955 18.6818 14.6836 18.7391 14.8882C18.7882 15.1009 18.7636 15.3218 18.6491 15.5182L18.4773 15.8291C18.3627 16.0173 18.1909 16.1482 17.9782 16.2055C17.7655 16.2627 17.5364 16.2382 17.3318 16.1155L17.2336 16.0664C16.4891 15.6327 15.5236 15.6327 14.7791 16.0664L14.4273 16.2709C14.0509 16.4918 13.74 16.7945 13.5273 17.1709C13.3145 17.5473 13.2 17.9727 13.2 18.3982V18.5455C13.2 18.7664 13.1182 18.9709 12.9627 19.1264C12.8073 19.2818 12.6027 19.3636 12.3818 19.3636H12.0218C11.8009 19.3636 11.5964 19.2818 11.4327 19.1264C11.2773 18.9709 11.1955 18.7664 11.1955 18.5455V18.39C11.1955 17.9564 11.0809 17.5391 10.8682 17.1627C10.6555 16.7945 10.3445 16.4836 9.97636 16.2709L9.62455 16.0664Z"
        fill={fill}
      />
    </svg>
  ),
  channelManagementIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path d="M22 8H2V22H22V8ZM3 9.16667H21V20.8333H3V9.16667Z" fill={fill} />
    //   <path
    //     d="M12 10C9.24 10 7 12.24 7 15C7 17.76 9.24 20 12 20C14.76 20 17 17.76 17 15C17 12.24 14.76 10 12 10ZM12 10.5C14.48 10.5 16.5 12.52 16.5 15C16.5 15.71 16.33 16.38 16.035 16.98C15.27 16.12 14.045 15.535 12.345 15.465C13.285 15.3 14 14.485 14 13.5C14 12.395 13.105 11.5 12 11.5C10.895 11.5 10 12.395 10 13.5C10 14.485 10.715 15.3 11.655 15.465C9.955 15.535 8.73 16.12 7.965 16.98C7.67 16.38 7.5 15.71 7.5 15C7.5 12.52 9.52 10.5 12 10.5ZM10.5 13.5C10.5 12.675 11.175 12 12 12C12.825 12 13.5 12.675 13.5 13.5C13.5 14.325 12.825 15 12 15C11.175 15 10.5 14.325 10.5 13.5ZM12 19.5C10.42 19.5 9.03 18.68 8.225 17.44C9.005 16.465 10.305 15.95 12 15.95C13.695 15.95 14.995 16.465 15.775 17.44C14.97 18.68 13.58 19.5 12 19.5Z"
    //     fill={fill}
    //   />
    //   <path d="M7 2L12.0002 8L17 2" stroke={fill} />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M24.84,23l2.47,1.61c1,.69,2.12,1.37,2.75,1.78a1.26,1.26,0,0,1,.51.45,1.57,1.57,0,0,1,.35,1,1.67,1.67,0,0,1-.29,1c.06.06-.4.46-.46.52-1.49,1.09-3.26,2.23-4.81,3.21l-.46.28a2.37,2.37,0,0,1-1.15.35,1.67,1.67,0,0,1-.91-.23c-.12-.06-.81-.58-.75-.69a2,2,0,0,1-.29-1V24.58a2,2,0,0,1,.23-1,1.86,1.86,0,0,1,.69-.75,1.6,1.6,0,0,1,1-.23A2,2,0,0,1,24.9,23Zm2.7-9.17A4.27,4.27,0,0,1,27,12.14v-.28a4.1,4.1,0,0,1,1-2.58,3.87,3.87,0,0,1,2.58-1.09h.06a3.69,3.69,0,0,1,2.52.91,3.61,3.61,0,0,1,1.21,2.7v.06a3.83,3.83,0,0,1-1,2.63,3.07,3.07,0,0,1-1.15.8A13.86,13.86,0,0,1,35,17.13a13.4,13.4,0,0,1,3.38,4.53,14.5,14.5,0,0,1,1.2,4.58l.18-.17a5.36,5.36,0,0,1,3.84-1.55h0a5.8,5.8,0,0,1,3.73,1.32,5.21,5.21,0,0,1,1.78,4V30a5.44,5.44,0,0,1-1.49,3.9,5.71,5.71,0,0,1-3.84,1.66h-.4a5.38,5.38,0,0,1-3.67-1.61,4.87,4.87,0,0,1-.92-1.26c-.06.18-.12.29-.17.46a12.46,12.46,0,0,1-2.87,4.53h0a14,14,0,0,1-4.41,3.1A15.75,15.75,0,0,1,25.87,42H25a13.56,13.56,0,0,1-5.05-1.15,13.94,13.94,0,0,1-4.35-3A14.73,14.73,0,0,1,14,36a6,6,0,0,1-1.43,2.52A6.24,6.24,0,0,1,8.16,40.4H7.7a6.21,6.21,0,0,1-4.18-1.83,6.58,6.58,0,0,1-1.89-4.24v-.46A6.2,6.2,0,0,1,3.4,29.51a6.52,6.52,0,0,1,4.42-1.83h0a6.5,6.5,0,0,1,3.56,1V27.28a15.85,15.85,0,0,1,1.09-5.39,12,12,0,0,1,2.86-4.3,14.26,14.26,0,0,1,4.42-2.93,16.14,16.14,0,0,1,5.39-1.14h.17c.74,0,1.49.06,2.18.11Zm.91-1.95v.23a2.41,2.41,0,0,0,.69,1.49,2.44,2.44,0,0,0,1.43.69h.23a2.41,2.41,0,0,0,1.49-.63A2.46,2.46,0,0,0,33,12.14V12a2.55,2.55,0,0,0-.51-1.55,2.44,2.44,0,0,0-1.61-.8h-.17a2.13,2.13,0,0,0-1.55.63A2.44,2.44,0,0,0,28.45,11.91ZM40,30v.34a3.37,3.37,0,0,0,1.14,2.35,3.76,3.76,0,0,0,2.35,1.09h.35a3.39,3.39,0,0,0,2.4-1.09,3.87,3.87,0,0,0,1.09-2.46V30a3.77,3.77,0,0,0-.86-2.47,3.73,3.73,0,0,0-2.63-1.26h-.29a3.5,3.5,0,0,0-2.47,1A4.07,4.07,0,0,0,39.92,30ZM3.58,34.1v.4a4.45,4.45,0,0,0,1.31,2.81A4,4,0,0,0,7.7,38.57h.4A4.35,4.35,0,0,0,11,37.31a5,5,0,0,0,1.32-2.93V34.1a4.89,4.89,0,0,0-1-2.93,4.45,4.45,0,0,0-3.09-1.49H7.87A4.11,4.11,0,0,0,5,30.89,4.68,4.68,0,0,0,3.63,34ZM25,40h.81a14.16,14.16,0,0,0,4.75-1,10.88,10.88,0,0,0,3.79-2.64,11,11,0,0,0,2.41-3.9,14,14,0,0,0,.8-4.7V27.5a13.31,13.31,0,0,0-1.09-5,10.88,10.88,0,0,0-2.87-3.9,12.3,12.3,0,0,0-3.84-2.24,13.44,13.44,0,0,0-4.47-.74h-.17a12.7,12.7,0,0,0-4.64,1,12.84,12.84,0,0,0-3.79,2.47,10.63,10.63,0,0,0-2.4,3.67,13,13,0,0,0-.92,4.64v.92a11.07,11.07,0,0,0,1,4.35A12,12,0,0,0,17,36.39a11.5,11.5,0,0,0,3.73,2.52,11.9,11.9,0,0,0,4.29,1Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  subscriptionIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //   onClick={onClick}
    //   width={width}
    //   height={height}
    //   className={className}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path d="M2 17V5H12V6H3V16H21V9H22V11V17H2Z" fill={fill} />
    //   <path d="M14 6.42857L16.7 9L23 3" stroke={fill} />
    //   <path d="M9 21L12.0001 17L15 21" stroke={fill} />
    //   <path d="M5 21H19" stroke={fill} />
    // </svg>

    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M10.7,11.74c4.62.06,9.18.12,13.79.12s9.18-.06,13.74-.12h0a4.21,4.21,0,0,1,2.75.9l.06.06-1.38,1.38a2.23,2.23,0,0,0-1.43-.42h0c-4.62.12-9.18.12-13.8.12s-9.17-.06-13.79-.12h-.06a3.48,3.48,0,0,0-1.8.42,1.67,1.67,0,0,0-.72,1.5V35.37A2.34,2.34,0,0,0,8.78,37a2,2,0,0,0,1.44.66l28.31.06a2.38,2.38,0,0,0,1.25-.48A1.82,1.82,0,0,0,40.26,36V21.82l1.92-2V36h0a3.59,3.59,0,0,1-3.59,3.72c-9.48,0-19-.06-28.49-.06a4,4,0,0,1-2.76-1.26,4.4,4.4,0,0,1-1.2-2.94h0V15.58A3.49,3.49,0,0,1,7.7,12.46a5.47,5.47,0,0,1,2.88-.78h.12ZM13.4,32h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,13.4,32Zm4.92,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,18.32,32Zm4.85,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,23.17,32ZM28,32h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72H28a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,28,32Zm4.86,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,32.89,32ZM13.46,15.58h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,13.46,15.58Zm4.92,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,18.38,15.58Zm4.85,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,23.23,15.58Zm4.86,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72h-2a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,28.09,15.58Zm4.86,0h2a.73.73,0,0,1,.72.72v2a.73.73,0,0,1-.72.72H33a.73.73,0,0,1-.72-.72v-2A.73.73,0,0,1,33,15.58ZM29,27.33l-4.14-4.26c-1-1.07.42-2.39,1.5-1.31l3.12,3c1,1,1.5.48,2.1-.12s8.63-8.33,9.29-9l1.92-1.92c1.32-1.38,2.7.3,1.74,1.26L41.46,18l-9.59,9.35-.24.24a1.68,1.68,0,0,1-2.34.06l-.36-.36Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  facebookIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 3.03748C7.02951 3.03748 3 7.06699 3 12.0375C3 16.4955 6.2447 20.1875 10.499 20.9024V13.9152H8.32795V11.4008H10.499V9.54673C10.499 7.39552 11.8129 6.22323 13.7322 6.22323C14.6515 6.22323 15.4414 6.29173 15.6708 6.3219V8.57049L14.3396 8.57113C13.296 8.57113 13.0948 9.06693 13.0948 9.79474V11.3995H15.5849L15.2601 13.9139H13.0948V20.9625C17.5478 20.4206 21 16.6346 21 12.035C21 7.06699 16.9705 3.03748 12.0001 3.03748Z"
        fill={fill}
      />
    </svg>
  ),
  twitterIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C7.0302 3 3 7.0302 3 12C3 16.9698 7.0302 21 12 21C16.9698 21 21 16.9698 21 12C21 7.0302 16.9698 3 12 3ZM16.1093 10.0172C16.1133 10.1058 16.1152 10.1948 16.1152 10.2842C16.1152 13.0139 14.0374 16.1616 10.2377 16.1618C9.07104 16.1618 7.98546 15.8198 7.07126 15.2338C7.23289 15.2529 7.39742 15.2624 7.564 15.2624C8.53189 15.2624 9.42261 14.9323 10.1297 14.3781C9.2254 14.3614 8.46295 13.7641 8.19983 12.9433C8.32576 12.9675 8.45526 12.9807 8.58806 12.9807C8.77661 12.9807 8.95926 12.9553 9.13284 12.9079C8.18761 12.7186 7.47556 11.8833 7.47556 10.883C7.47556 10.8736 7.47556 10.8652 7.47583 10.8566C7.7542 11.0114 8.07253 11.1045 8.41145 11.1149C7.85678 10.7448 7.49217 10.1121 7.49217 9.39542C7.49217 9.01694 7.59448 8.66235 7.77191 8.35707C8.79062 9.60704 10.313 10.4291 12.0299 10.5155C11.9945 10.3641 11.9762 10.2065 11.9762 10.0444C11.9762 8.90405 12.9014 7.97887 14.0422 7.97887C14.6364 7.97887 15.1731 8.23004 15.5501 8.63159C16.0207 8.53876 16.4626 8.36682 16.8619 8.1302C16.7074 8.61237 16.38 9.01694 15.9534 9.27278C16.3713 9.22279 16.7696 9.11197 17.1397 8.94745C16.8632 9.36177 16.5126 9.72569 16.1093 10.0172Z"
        fill={fill}
      />
    </svg>
  ),
  linkedinIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 3C7.0302 3 3 7.0302 3 12C3 16.9698 7.0302 21 12 21C16.9698 21 21 16.9698 21 12C21 7.0302 16.9698 3 12 3ZM9.3847 16.6055H7.19279V10.0111H9.3847V16.6055ZM8.28882 9.1106H8.27454C7.539 9.1106 7.06329 8.60426 7.06329 7.97145C7.06329 7.32436 7.55356 6.83203 8.30338 6.83203C9.05319 6.83203 9.51462 7.32436 9.5289 7.97145C9.5289 8.60426 9.05319 9.1106 8.28882 9.1106ZM17.2883 16.6055H15.0966V13.0776C15.0966 12.191 14.7793 11.5864 13.9862 11.5864C13.3807 11.5864 13.0201 11.9942 12.8616 12.388C12.8036 12.5289 12.7895 12.7258 12.7895 12.9229V16.6055H10.5977C10.5977 16.6055 10.6264 10.6297 10.5977 10.0111H12.7895V10.9448C13.0808 10.4954 13.6019 9.85629 14.7648 9.85629C16.2069 9.85629 17.2883 10.7988 17.2883 12.8242V16.6055Z"
        fill={fill}
      />
    </svg>
  ),
  LogoIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    // <svg
    //       onClick={onClick}
    //       width={width}
    //       height={height}
    //       className={className}
    // viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    // <path fillRule="evenodd" clipRule="evenodd" d="M3.46896 4.92512L2.35742 5.56687C1.89332 5.83482 1.60742 6.33001 1.60742 6.86591V8.1494H3.10742V6.86591L4.21896 6.22416L3.46896 4.92512ZM1.60742 15.8504H3.10742V17.1339L4.21896 17.7756L3.46896 19.0746L2.35742 18.4329C1.89332 18.1649 1.60742 17.6698 1.60742 17.1339V15.8504ZM5.69204 20.3581L6.44204 19.0591L8.66511 20.3426L7.91511 21.6416L5.69204 20.3581ZM10.1382 22.9251L10.8882 21.6261L11.9997 22.2678L13.1113 21.6261L13.8613 22.9251L12.7497 23.5669C12.2856 23.8348 11.7138 23.8348 11.2497 23.5669L10.1382 22.9251ZM16.0843 21.6416L15.3343 20.3426L17.5574 19.0591L18.3074 20.3581L16.0843 21.6416ZM22.392 8.1494H20.892V6.86591L19.7805 6.22416L20.5305 4.92512L21.642 5.56687C22.1061 5.83482 22.392 6.33001 22.392 6.86591V8.1494ZM18.3074 3.64163L16.0843 2.35814L15.3343 3.65717L17.5574 4.94067L18.3074 3.64163ZM13.8613 1.07464L13.1113 2.37368L11.9997 1.73193L10.8882 2.37368L10.1382 1.07464L11.2497 0.432895C11.7138 0.164946 12.2856 0.164946 12.7497 0.432896L13.8613 1.07464ZM7.91511 2.35814L8.66511 3.65717L6.44204 4.94067L5.69204 3.64163L7.91511 2.35814ZM22.392 10.7164H20.892V13.2834H22.392V10.7164ZM22.392 15.8504H20.892V17.1339L19.7805 17.7756L20.5305 19.0746L21.642 18.4329C22.1061 18.1649 22.392 17.6698 22.392 17.1339V15.8504ZM1.60742 13.2834H3.10742V10.7164H1.60742V13.2834Z" fill="url(#paint0_radial_6005_6114)"/>
    // <path d="M9.1875 8.71875C8.0625 10.0312 4.125 11.3438 3 12C4.125 12.6562 8.0625 13.9688 9.1875 15.2812C10.3125 16.5938 11.4375 21.1875 12 22.5C12.5625 21.1875 13.6875 16.5938 14.8125 15.2812C15.9375 13.9688 19.875 12.6562 21 12C19.875 11.3438 15.9375 10.0312 14.8125 8.71875C13.6875 7.40625 12.5625 2.8125 12 1.5C11.4375 2.8125 10.3125 7.40625 9.1875 8.71875Z" fill={fill}/>
    // <defs>
    // <radialGradient id="paint0_radial_6005_6114" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(11.9997 23.7678) rotate(-90) scale(23.5359 20.7846)">
    // <stop stopColor="#0059B2"/>
    // <stop offset="1" stopColor="#008AB0"/>
    // </radialGradient>
    // </defs>
    // </svg>

    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.46896 4.92512L2.35742 5.56687C1.89332 5.83482 1.60742 6.33001 1.60742 6.86591V8.1494H3.10742V6.86591L4.21896 6.22416L3.46896 4.92512ZM1.60742 15.8504H3.10742V17.1339L4.21896 17.7756L3.46896 19.0746L2.35742 18.4329C1.89332 18.1649 1.60742 17.6698 1.60742 17.1339V15.8504ZM5.69204 20.3581L6.44204 19.0591L8.66511 20.3426L7.91511 21.6416L5.69204 20.3581ZM10.1382 22.9251L10.8882 21.6261L11.9997 22.2678L13.1113 21.6261L13.8613 22.9251L12.7497 23.5669C12.2856 23.8348 11.7138 23.8348 11.2497 23.5669L10.1382 22.9251ZM16.0843 21.6416L15.3343 20.3426L17.5574 19.0591L18.3074 20.3581L16.0843 21.6416ZM22.392 8.1494H20.892V6.86591L19.7805 6.22416L20.5305 4.92512L21.642 5.56687C22.1061 5.83482 22.392 6.33001 22.392 6.86591V8.1494ZM18.3074 3.64163L16.0843 2.35814L15.3343 3.65717L17.5574 4.94067L18.3074 3.64163ZM13.8613 1.07464L13.1113 2.37368L11.9997 1.73193L10.8882 2.37368L10.1382 1.07464L11.2497 0.432895C11.7138 0.164946 12.2856 0.164946 12.7497 0.432896L13.8613 1.07464ZM7.91511 2.35814L8.66511 3.65717L6.44204 4.94067L5.69204 3.64163L7.91511 2.35814ZM22.392 10.7164H20.892V13.2834H22.392V10.7164ZM22.392 15.8504H20.892V17.1339L19.7805 17.7756L20.5305 19.0746L21.642 18.4329C22.1061 18.1649 22.392 17.6698 22.392 17.1339V15.8504ZM1.60742 13.2834H3.10742V10.7164H1.60742V13.2834Z"
        fill="url(#paint0_radial_6098_11381)"
      />
      <path
        d="M9.1875 8.71875C8.0625 10.0312 4.125 11.3438 3 12C4.125 12.6562 8.0625 13.9688 9.1875 15.2812C10.3125 16.5938 11.4375 21.1875 12 22.5C12.5625 21.1875 13.6875 16.5938 14.8125 15.2812C15.9375 13.9688 19.875 12.6562 21 12C19.875 11.3438 15.9375 10.0312 14.8125 8.71875C13.6875 7.40625 12.5625 2.8125 12 1.5C11.4375 2.8125 10.3125 7.40625 9.1875 8.71875Z"
        fill={fill}
      />
      <defs>
        <radialGradient
          id="paint0_radial_6098_11381"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(11.9997 23.7678) rotate(-90) scale(23.5359 20.7846)"
        >
          <stop stopColor="#0059B2" />
          <stop offset="1" stopColor="#008AB0" />
        </radialGradient>
      </defs>
    </svg>
  ),
  contactusIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M7.56,21.49a17.93,17.93,0,0,1,35.83,0V37.61a8.07,8.07,0,0,1-8,8c-4.49,0-8.89,0-13.46,0-.49,0-.62-.78-.62-1.55a2.92,2.92,0,0,1,2.9-2.9h4a3.15,3.15,0,0,1,2.61,2.9c1,0,2.57,0,4,0,2.61,0,5.88-1.55,6.25-4.16H38.94a4.46,4.46,0,0,1-4.44-4.45V26a4.46,4.46,0,0,1,4.44-4.45h2.62C41.23,13.9,35.15,5.94,25.4,6.11,15.44,5.86,9.32,14.76,9,21.53h2.94A4.46,4.46,0,0,1,16.34,26v9.51a4.45,4.45,0,0,1-8.9,0v-14Zm10.41-3a2.14,2.14,0,0,1,.57-1.59,2.06,2.06,0,0,1,1.35-.53,1.92,1.92,0,0,1,1.83,1.75,2,2,0,0,1-2,2A1.82,1.82,0,0,1,18,18.47Zm5.88,0a2.1,2.1,0,0,1,.57-1.59,2,2,0,0,1,1.34-.53A1.93,1.93,0,0,1,27.6,18.1a2,2,0,0,1-2,2A1.82,1.82,0,0,1,23.85,18.47Zm5.91,0a2.18,2.18,0,0,1,.57-1.59,2.06,2.06,0,0,1,1.35-.53,1.93,1.93,0,0,1,1.84,1.75,2,2,0,0,1-2,2A1.83,1.83,0,0,1,29.76,18.47Z"
          fill={fill}
          fillRule="evenodd"
        />
      </g>
    </svg>
  ),
  CopyIcon: ({
    width = '20px',
    height = '20px',
    className = '',
    onClick,
    fill = 'var(--icon-color)',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      // fill={fill}
      className={className}
      onClick={onClick}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M19.82,13.36a2.63,2.63,0,0,0-2.58,2.58v24a2.63,2.63,0,0,0,2.58,2.58H35.93a2.63,2.63,0,0,0,2.58-2.58v-24a2.7,2.7,0,0,0-2.58-2.58Zm16.11,3.88V38.91a1,1,0,0,1-1,1H20.82a1,1,0,0,1-1-1c0-7.26,0-14.42.1-21.67a.94.94,0,0,1,1-1c4.77,0,9.44-.1,14.21-.1a.9.9,0,0,1,1,1Zm-21.18-9a2.63,2.63,0,0,0-2.58,2.58V33.54a1.3,1.3,0,1,0,2.58,0V12.86a1.92,1.92,0,0,1,1.89-2H30.36a1.29,1.29,0,1,0,0-2.58H14.75Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  SampleUsericon: ({
    width = '20px',
    height = '20px',
    className = '',
    onClick,
    fill = 'var(--icon-color)',
  }) => (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      // fill={fill}
      className={className}
      onClick={onClick}
      viewBox="0 0 50.68 50.68"
    >
      <g id="Layer_1-2" data-name="Layer_1">
        <path
          d="M19.82,13.36a2.63,2.63,0,0,0-2.58,2.58v24a2.63,2.63,0,0,0,2.58,2.58H35.93a2.63,2.63,0,0,0,2.58-2.58v-24a2.7,2.7,0,0,0-2.58-2.58Zm16.11,3.88V38.91a1,1,0,0,1-1,1H20.82a1,1,0,0,1-1-1c0-7.26,0-14.42.1-21.67a.94.94,0,0,1,1-1c4.77,0,9.44-.1,14.21-.1a.9.9,0,0,1,1,1Zm-21.18-9a2.63,2.63,0,0,0-2.58,2.58V33.54a1.3,1.3,0,1,0,2.58,0V12.86a1.92,1.92,0,0,1,1.89-2H30.36a1.29,1.29,0,1,0,0-2.58H14.75Z"
          fill={fill}
        />
      </g>
    </svg>
  ),
  CalendarIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="15" height="15" rx="2.5" stroke={fill} />
      <rect x="4" width="1" height="5" rx="0.5" fill={fill} />
      <rect x="11" width="1" height="5" rx="0.5" fill={fill} />
      <rect x="3" y="7" width="10" height="6" fill={fill} />
    </svg>
  ),
  DownIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.793 6.5L8 10.293L4.20703 6.5H11.793Z" stroke={fill} />
    </svg>
  ),
  DownIconFill: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.793 6.5L8 10.293L4.20703 6.5H11.793Z" fill={fill} stroke={fill} />
    </svg>
  ),

  EmailIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6024_9099)">
        <rect x="0.5" y="3.5" width="15" height="9" rx="0.5" stroke={fill} />
        <path
          d="M0 13.5L16 13.5L8 6L0 13.5Z"
          fill="var(--bg-form-color)"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 1.5H0L8 9L16 1.5Z"
          fill="var(--bg-form-color)"
          stroke={fill}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6024_9099">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  FileIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2.5" y="0.5" width="11" height="15" rx="0.5" stroke={fill} />
      <path d="M9 0.5L13.5 5" stroke={fill} strokeLinecap="round" />
    </svg>
  ),
  uploadIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6024_9114)">
        <path
          d="M0.5 10.5V14.5C0.5 15.0523 0.947715 15.5 1.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5V10.5"
          stroke={fill}
          strokeLinecap="round"
        />
        <path d="M8 12V1" stroke={fill} strokeWidth="2" strokeLinecap="round" />
        <path
          d="M4 5L7.64645 1.35355C7.84171 1.15829 8.15829 1.15829 8.35355 1.35355L12 5"
          stroke={fill}
          strokeWidth="2"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6024_9114">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  ImageIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6024_9122)">
        <circle cx="12" cy="6" r="1.5" stroke={fill} />
        <path
          d="M4.5 6.5L0.5 13.5H13.5L9.5 9.5L8.5 10.5L4.5 6.5Z"
          stroke={fill}
          strokeLinecap="round"
        />
      </g>
      <rect x="0.5" y="2.5" width="15" height="11" stroke={fill} />
      <defs>
        <clipPath id="clip0_6024_9122">
          <rect y="2" width="16" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  PlusIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7" y="2" width="2" height="12" rx="1" fill={fill} />
      <rect x="2" y="7" width="12" height="2" rx="1" fill={fill} />
    </svg>
  ),
  ArrowLongRight: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6058_9989)">
        <path d="M0.5 8L15.5 8" stroke={fill} strokeLinecap="round" />
        <path
          d="M11 12.5L15.1464 8.35355C15.3417 8.15829 15.3417 7.84171 15.1464 7.64645L11 3.5"
          stroke={fill}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6058_9989">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  RecetHistoryIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
    activeFill = 'none',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6058_10008)">
        <g clipPath="url(#clip1_6058_10008)">
          <path
            fill={activeFill}
            d="M7.70801 0.5H8.5C12.366 0.5 15.5 3.63401 15.5 7.5V7.71875C15.5 11.4639 12.4639 14.5 8.71875 14.5C7.66614 14.5 6.62802 14.2549 5.68652 13.7842L5.02246 13.4521L4.81445 13.5361L0.850586 15.1211L2.46973 10.6709L2.53516 10.4912L2.46387 10.3145L1.94434 9.01367C1.65101 8.28037 1.5 7.4978 1.5 6.70801C1.50007 3.27945 4.27945 0.500067 7.70801 0.5Z"
            stroke={fill}
          />
        </g>
        <g clipPath="url(#clip2_6058_10008)">
          <circle cx="12" cy="12" r="5" fill="#9ECFFF" stroke="#2A3038" strokeWidth="2" />
          <rect x="11.5" y="8.5" width="1" height="4" rx="0.5" fill="#2A3038" />
          <path d="M12 12L13.9999 11.5" stroke="#2A3038" strokeLinecap="round" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6058_10008">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_6058_10008">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip2_6058_10008">
          <rect width="10" height="10" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  FavoriteHistoryIcon: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
    activeFill = 'none',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6058_10038)">
        <g clipPath="url(#clip1_6058_10038)">
          <path
            fill={activeFill}
            d="M7.70801 0.5H8.5C12.366 0.5 15.5 3.63401 15.5 7.5V7.71875C15.5 11.4639 12.4639 14.5 8.71875 14.5C7.66614 14.5 6.62802 14.2549 5.68652 13.7842L5.02246 13.4521L4.81445 13.5361L0.850586 15.1211L2.46973 10.6709L2.53516 10.4912L2.46387 10.3145L1.94434 9.01367C1.65101 8.28037 1.5 7.4978 1.5 6.70801C1.50007 3.27945 4.27945 0.500067 7.70801 0.5Z"
            stroke={fill}
          />
        </g>
        <g clipPath="url(#clip2_6058_10038)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12.123 9.45492L11.0004 6L9.87783 9.45492H6.24512L9.18404 11.5902L8.06147 15.0451L11.0004 12.9098L13.9393 15.0451L12.8168 11.5902L15.7557 9.45492H12.123ZM12.678 10.4549H11.3964L11.0004 9.23607L10.6044 10.4549H9.3228L10.3596 11.2082L9.96359 12.4271L11.0004 11.6738L12.0372 12.4271L11.6412 11.2082L12.678 10.4549Z"
            fill="#9ECFFF"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6058_10038">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_6058_10038">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip2_6058_10038">
          <rect width="10" height="10" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  UpgradePlan: ({
    width = '16px',
    height = '16px',
    className = '',
    onClick = null,
    fill = 'var(--icon-color-grid)',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6058_10118)">
        <g clipPath="url(#clip1_6058_10118)">
          <path
            d="M8 10.5C12.7834 10.5 14.9336 13.032 15.3994 15.1172C15.4207 15.2127 15.3944 15.296 15.3291 15.3662C15.2586 15.4419 15.141 15.5 15 15.5H1C0.859016 15.5 0.741421 15.4419 0.670898 15.3662C0.605627 15.296 0.579253 15.2127 0.600586 15.1172C1.06643 13.032 3.21657 10.5 8 10.5Z"
            stroke={fill}
          />
          <circle cx="8" cy="4" r="3.5" stroke={fill} />
        </g>
        <g clipPath="url(#clip2_6058_10118)">
          <path
            d="M10.4141 13.8282C9.63301 14.6093 8.36699 14.6093 7.58594 13.8282C6.80489 13.0472 6.80489 11.7812 7.58594 11.0001L11.293 7.29309C11.4805 7.10555 11.7348 7.00012 12 7.00012C12.2652 7.00012 12.5195 7.10555 12.707 7.29309L16.4141 11.0001C17.1951 11.7812 17.1951 13.0472 16.4141 13.8282C15.633 14.6093 14.367 14.6093 13.5859 13.8282L12 12.2423L10.4141 13.8282Z"
            fill="#9ECFFF"
            stroke="#2A3038"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <rect
            x="14"
            y="16.9142"
            width="4"
            height="9"
            transform="rotate(-180 14 16.9142)"
            fill="#9ECFFF"
            stroke="#2A3038"
            strokeWidth="2"
            strokeLinejoin="round"
          />
          <path
            d="M15 12.4142L12 9.41418L9 12.4142"
            stroke="#9ECFFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6058_10118">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_6058_10118">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip2_6058_10118">
          <rect width="10" height="10" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),

  ToolbarIcon1: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6005_2140)">
        <g clipPath="url(#clip1_6005_2140)">
          <circle cx="8" cy="8" r="7.5" stroke={fill} />
          <circle cx="8" cy="4" r="1.5" fill={fill} />
          <path d="M8 7.5V8.5" stroke={fill} strokeWidth="2" strokeLinecap="round" />
          <path d="M4.50037 6.00006L7.50037 7.00005" stroke={fill} strokeLinecap="round" />
          <path d="M11.5002 6.00006L8.50016 7.00008" stroke={fill} strokeLinecap="round" />
          <path d="M10.5 12.5L8.5 8.5" stroke={fill} strokeLinecap="round" />
          <path d="M5.5001 12.5L7.50009 8.5" stroke={fill} strokeLinecap="round" />
        </g>
        <g clipPath="url(#clip2_6005_2140)">
          <mask
            id="path-8-outside-1_6005_2140"
            maskUnits="userSpaceOnUse"
            x="12"
            y="6"
            width="6"
            height="12"
            fill="black"
          >
            <rect fill="white" x="12" y="6" width="6" height="12" />
            <path fillRule="evenodd" clipRule="evenodd" d="M16 8H14V13H16V8ZM16 14H14V16H16V14Z" />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 8H14V13H16V8ZM16 14H14V16H16V14Z"
            fill="#9ECFFF"
          />
          <path
            d="M14 8V6C12.8954 6 12 6.89543 12 8H14ZM16 8H18C18 6.89543 17.1046 6 16 6V8ZM14 13H12C12 14.1046 12.8954 15 14 15V13ZM16 13V15C17.1046 15 18 14.1046 18 13H16ZM14 14V12C12.8954 12 12 12.8954 12 14H14ZM16 14H18C18 12.8954 17.1046 12 16 12V14ZM14 16H12C12 17.1046 12.8954 18 14 18V16ZM16 16V18C17.1046 18 18 17.1046 18 16H16ZM14 10H16V6H14V10ZM16 13V8H12V13H16ZM16 11H14V15H16V11ZM14 8V13H18V8H14ZM14 16H16V12H14V16ZM16 16V14H12V16H16ZM16 14H14V18H16V14ZM14 14V16H18V14H14Z"
            fill="#2A3038"
            mask="url(#path-8-outside-1_6005_2140)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6005_2140">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_6005_2140">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip2_6005_2140">
          <rect width="10" height="10" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  ToolbarIcon2: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6005_2132)">
        <g clipPath="url(#clip1_6005_2132)">
          <path
            d="M7.70801 0.5H8.5C12.366 0.5 15.5 3.63401 15.5 7.5V7.71875C15.5 11.4639 12.4639 14.5 8.71875 14.5C7.66614 14.5 6.62802 14.2549 5.68652 13.7842L5.02246 13.4521L4.81445 13.5361L0.850586 15.1211L2.46973 10.6709L2.53516 10.4912L2.46387 10.3145L1.94434 9.01367C1.65101 8.28037 1.5 7.4978 1.5 6.70801C1.50007 3.27945 4.27945 0.500067 7.70801 0.5Z"
            stroke={fill}
          />
        </g>
        <g clipPath="url(#clip2_6005_2132)">
          <mask
            id="path-2-outside-1_6005_2132"
            maskUnits="userSpaceOnUse"
            x="6"
            y="6"
            width="12"
            height="12"
            fill="black"
          >
            <rect fill="white" x="6" y="6" width="12" height="12" />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12ZM10 14C8.89543 14 8 14.8954 8 16H16C16 14.8954 15.1046 14 14 14H10Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12ZM10 14C8.89543 14 8 14.8954 8 16H16C16 14.8954 15.1046 14 14 14H10Z"
            fill="#9ECFFF"
          />
          <path
            d="M8 16H6C6 17.1046 6.89543 18 8 18V16ZM16 16V18C17.1046 18 18 17.1046 18 16H16ZM12 10V14C14.2091 14 16 12.2091 16 10H12ZM12 10H16C16 7.79086 14.2091 6 12 6V10ZM12 10V6C9.79086 6 8 7.79086 8 10H12ZM12 10H8C8 12.2091 9.79086 14 12 14V10ZM10 16V12C7.79086 12 6 13.7909 6 16H10ZM16 14H8V18H16V14ZM14 16H18C18 13.7909 16.2091 12 14 12V16ZM10 16H14V12H10V16Z"
            fill="#2A3038"
            mask="url(#path-2-outside-1_6005_2132)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6005_2132">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_6005_2132">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip2_6005_2132">
          <rect width="10" height="10" fill="white" transform="translate(6 6)" />
        </clipPath>
      </defs>
    </svg>
  ),
  ToolbarIcon3: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6005_6143)">
        <path
          d="M7.5 6.5H12.1914L8.5 13.8818V9.5H2.88281L7.5 1.80469V6.5Z"
          stroke={fill}
          strokeLinecap="round"
        />
        <path d="M11 11L13 6H13.5V10H16V11L14 16H13.5V12H11V11Z" fill="#9ECFFF" />
      </g>
      <defs>
        <clipPath id="clip0_6005_6143">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  ToolbarIcon4: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6012_125)">
        <path
          d="M6.5 11.5H9.5M2.5 13.5H13.5C14.6046 13.5 15.5 12.6046 15.5 11.5V4.5C15.5 3.39543 14.6046 2.5 13.5 2.5H2.5C1.39543 2.5 0.5 3.39543 0.5 4.5V11.5C0.5 12.6046 1.39543 13.5 2.5 13.5Z"
          stroke={fill}
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_6012_125">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  CircleCenterIcon: ({
    width = '16px',
    height = '16px',
    fill = 'var(--icon-color)',
    onClick = null,
    className = '',
  }) => (
    <svg
      onClick={onClick}
      width={width}
      height={height}
      className={className}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_6122_1707)">
        <g clipPath="url(#clip1_6122_1707)">
          <circle cx="8" cy="8" r="7.5" stroke={fill} />
          <circle cx="8" cy="8" r="3.5" stroke={fill} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_6122_1707">
          <rect width="16" height="16" fill="white" />
        </clipPath>
        <clipPath id="clip1_6122_1707">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

export default ToolbarIcons;
